/**
 * A function to create a log object for the 'openGeneratorClickSrc63Evid1' event (evid: 1)
 *
 * Event description: Calling point for AI Generator
 *
 * @param {openGeneratorClickSrc63Evid1Params} params - The parameters for this event
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator:panel, component, popover
 * @return {LogObject<openGeneratorClickSrc63Evid1Params>} LogObject<openGeneratorClickSrc63Evid1Params>
 */
export function openGeneratorClickSrc63Evid1(params) {
    return { evid: 1, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiPanelErrorSentSrc63Evid10' event (evid: 10)
 *
 * Event description: Received error details
 *
 * @param {aiPanelErrorSentSrc63Evid10Params} params - The parameters for this event
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @property {string} error - Error text
 * @property {string} errorType - Type of the error
 * @property {string} origin - origin of an error
 * @return {LogObject<aiPanelErrorSentSrc63Evid10Params>} LogObject<aiPanelErrorSentSrc63Evid10Params>
 */
export function aiPanelErrorSentSrc63Evid10(params) {
    return { evid: 10, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageDisplayedSrc63Evid100' event (evid: 100)
 *
 * Event description: message displayed
 *
 * @param {messageDisplayedSrc63Evid100Params} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} msg_type - {error, notification}
 * @property {string} msg_desc - {welcome, finish_set_up, 'name already exists', 'API not available'...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<messageDisplayedSrc63Evid100Params>} LogObject<messageDisplayedSrc63Evid100Params>
 */
export function messageDisplayedSrc63Evid100(params) {
    return { evid: 100, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'legendsChatConversationSrc63Evid1001' event (evid: 1001)
 *
 * Event description: Event on chat conversation details
 *
 * @param {legendsChatConversationSrc63Evid1001Params} params - The parameters for this event
 * @property {string} conversation_id - unique identifier of conversation
 * @property {string} conversation_status - started/finished
 * @property {string} conversation_duration - if finished
 * @property {string} finish_reason - success/error
 * @return {LogObject<legendsChatConversationSrc63Evid1001Params>} LogObject<legendsChatConversationSrc63Evid1001Params>
 */
export function legendsChatConversationSrc63Evid1001(params) {
    return { evid: 1001, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'statusChanged' event (evid: 102)
 *
 * Event description: status_changed
 *
 * @param {statusChangedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} old_status - {connected, disconnected, activated...}
 * @property {string} market - {editor,dashboard,ADI}
 * @property {GUID} site_id - ----- DEPRECATED ----- send empty
 * @property {GUID} biToken - msid
 * @property {string} description - description
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} user_id - IG user_id
 * @property {string} api_description - api error description
 * @property {string} new_status - {connected, disconnected, activated...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - {connect_account, feature_activation...}
 * @property {string} instance_id - comp_id
 * @return {LogObject<statusChangedParams>} LogObject<statusChangedParams>
 */
export function statusChanged(params) {
    return { evid: 102, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTab' event (evid: 11)
 *
 * Event description: click on tab
 *
 * @param {clickOnTabParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<clickOnTabParams>} LogObject<clickOnTabParams>
 */
export function clickOnTab(params) {
    return { evid: 11, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'welcomePageLoaded' event (evid: 110)
 *
 * Event description: welcome page loaded
 *
 * @param {welcomePageLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} market - {editor,dashboard}
 * @property {string} state - free text to describe state when page loaded
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - tab_name
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<welcomePageLoadedParams>} LogObject<welcomePageLoadedParams>
 */
export function welcomePageLoaded(params) {
    return { evid: 110, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickUpgrade' event (evid: 12)
 *
 * Event description: click upgrade
 *
 * @param {clickUpgradeParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} sub_origin - {header, tab, footer}
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<clickUpgradeParams>} LogObject<clickUpgradeParams>
 */
export function clickUpgrade(params) {
    return { evid: 12, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'appPublished' event (evid: 120)
 *
 * Event description: site published with app
 *
 * @param {appPublishedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} value1 - param to enter free text to describe the specific scenario
 * @property {string} app_status - {set_up_completed,...}
 * @property {GUID} app_id - app_id
 * @property {string} value2 - param to enter free text to describe the specific scenario
 * @property {string} instance_id - in editor events this is sent as app_site_id
 * @return {LogObject<appPublishedParams>} LogObject<appPublishedParams>
 */
export function appPublished(params) {
    return { evid: 120, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'selector' event (evid: 13)
 *
 * Event description: selector
 *
 * @param {selectorParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} sub_tab - inside a tab there are more tabs
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} selector_group_name - {layout, icon_set...}
 * @property {string} selected_item_name - {vertical, mini,...}
 * @property {string} selector_type - {thmbnail, radio_button, dropdown...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {number} selected_item_position - {1,2,3...}
 * @property {number} num_items - {3,4,5...}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<selectorParams>} LogObject<selectorParams>
 */
export function selector(params) {
    return { evid: 13, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'numericInput' event (evid: 14)
 *
 * Event description: relevant for FAQ app only
 *
 * @param {numericInputParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} input_name - {width, hight...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @property {number} input - {5,10,15...}
 * @return {LogObject<numericInputParams>} LogObject<numericInputParams>
 */
export function numericInput(params) {
    return { evid: 14, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'checkBox' event (evid: 15)
 *
 * Event description: check_box
 *
 * @param {checkBoxParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} check_box_name - {layout, icon_set...}
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {boolean} is_selected - {TRUE,FALSE}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<checkBoxParams>} LogObject<checkBoxParams>
 */
export function checkBox(params) {
    return { evid: 15, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tooltipClick' event (evid: 16)
 *
 * Event description: tooltip click
 *
 * @param {tooltipClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} tooltip_type - {select_language, redirect, disable_redirect
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<tooltipClickParams>} LogObject<tooltipClickParams>
 */
export function tooltipClick(params) {
    return { evid: 16, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'linkClick' event (evid: 17)
 *
 * Event description: link click
 *
 * @param {linkClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} link_description - link_description
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} link_type - {external,.....}
 * @property {string} instance_id - instance_id
 * @return {LogObject<linkClickParams>} LogObject<linkClickParams>
 */
export function linkClick(params) {
    return { evid: 17, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'buttonClick' event (evid: 18)
 *
 * Event description: button click
 *
 * @param {buttonClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} sub_tab - inside a tab there are more tabs
 * @property {string} button_description - button_description
 * @property {string} button_type - {external,.....}
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - type
 * @property {string} instance_id - instance_id
 * @return {LogObject<buttonClickParams>} LogObject<buttonClickParams>
 */
export function buttonClick(params) {
    return { evid: 18, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'toggle' event (evid: 19)
 *
 * Event description: toggle
 *
 * @param {toggleParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} sub_tab - sub_tab : "categories","home_page"
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} selected_item_name - {show, hide...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {string} toggle_name - {layout, icon_set...}
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<toggleParams>} LogObject<toggleParams>
 */
export function toggle(params) {
    return { evid: 19, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsSaveButtonSrc63Evid2' event (evid: 2)
 *
 * Event description: Save prompt settings
 *
 * @param {settingsSaveButtonSrc63Evid2Params} params - The parameters for this event
 * @property {string} promptSettings - Json with all relevant settings like business name
 * @property {string} toneOfVoice - List of tone of voice choices
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @return {LogObject<settingsSaveButtonSrc63Evid2Params>} LogObject<settingsSaveButtonSrc63Evid2Params>
 */
export function settingsSaveButtonSrc63Evid2(params) {
    return { evid: 2, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramfeedDetails' event (evid: 200)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site. For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {instagramfeedDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {boolean} wixlabs_bool_13 - [Layout] show more (load more) button (hashtag feed) displayed - desktop = true / false
 * @property {number} wixlabs_num_4 - [Layout] number of columns hashtag feed  (don't send if layout = slider)
 * @property {boolean} wixlabs_bool_14 - [Layout] show more (load more) button (hashtag feed ) displayed - Mobile = true / false
 * @property {boolean} wixlabs_bool_2 - is_full_width
 * @property {boolean} wixlabs_bool_3 - 'show more' button displayed in Desktop - true / false
 * @property {string} wixlabs_string_16 - [Design] posts info - counters / captions
 * @property {boolean} wixlabs_bool_9 - [Settings] enable hover on post - true / false
 * @property {string} wixlabs_string_12 - [Text]  gallery title on hashtag feed =  show hashtag / costum title / no title
 * @property {GUID} site_id - [ DEPRECATED ]   ---> send empty
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_7 - - error - if the user doesn't have an error then null, if he has an error then the error description
 * @property {number} wixlabs_num_3 - ADI - selected STYLE #
 * @property {string} wixlabs_string_4 - show more button - button / icon
 * @property {string} event_trigger - Send empty
 * @property {string} wixlabs_string_3 - [Layout] number of rows hashtag feed  - Desktop
 * @property {string} wixlabs_string_13 - [Layout] layout order - profile-posts-hashtag / profile-hashtag-posts /  hashtag-posts-profile / hashtag-profile-posts / posts-hashtag-profile / posts-profile-hashtag
 * @property {boolean} wixlabs_bool_12 - [Layout] hashtag feed layout -text alignment true = left, false = center
 * @property {string} wixlabs_string_8 - IG user_id
 * @property {string} wixlabs_string_17 - [Design] expand mode - post - what info to display -  string that contains all the parameters that the user chose. captions / comments and replies / counters / timesptamp
 * @property {boolean} wixlabs_bool_4 - 'show more' button displayed in Mobile - true / false
 * @property {boolean} wixlabs_bool_6 - [Display] profile info ("your profile") shown = true / false
 * @property {boolean} wixlabs_bool_10 - [Settings] app direction - true = left to right, false - right to left
 * @property {boolean} wixlabs_bool_1 - is_connected to instagram account
 * @property {string} wixlabs_string_9 - [Display] which profile info is shown - string that contains all the parameters that the user chose. (username / profile photo and stories / total posts / followers / following / bio / follow button)
 * @property {string} wixlabs_string_14 - [Layout] your profile layout - profile photo shape - circle / rounded / square
 * @property {string} wixlabs_string_2 - [Layout] selected layout - posts feed - mobile = grid1 / grid2 / grid3 / slider
 * @property {boolean} wixlabs_bool_11 - [Layout] your profile layout true = classic, false = center
 * @property {boolean} wixlabs_bool_7 - [Display] posts feed ("your posts") shown = true / false
 * @property {number} wixlabs_num_2 - number of columns (don't send if layout = slider)
 * @property {boolean} wixlabs_bool_5 - [Layout] show more (load more) design = true = button / false = + icon
 * @property {boolean} wixlabs_bool_15 - [Design] expand mode - story - autoplay sound on = true / false
 * @property {string} wixlabs_string_5 - [Settings] selected language
 * @property {string} wixlabs_string_10 - [Settings] when clicking on profile photo - show stories / open on instagram / nothing happens
 * @property {number} wixlabs_num_5 - [Display] number of hashtags displayed
 * @property {string} wixlabs_string_15 - [Layout] selected layout hashtag feed - desktop = grid / collage / slider
 * @property {boolean} wixlabs_bool_8 - [Display] hashtag feed shown = true / false
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - number of rows
 * @property {string} wixlabs_string_11 - [Settings] when clicking on a post - expand to full screen / open on instagram / nothing happens
 * @property {string} wixlabs_string_1 - [Layout] selected layout posts feed - desktop = grid / collage / slider
 * @property {string} instance_id - comp_id
 * @property {string} wixlabs_string_6 - account type - business / personal / demo
 * @return {LogObject<instagramfeedDetailsParams>} LogObject<instagramfeedDetailsParams>
 */
export function instagramfeedDetails(params) {
    return { evid: 200, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleCalendarDetails' event (evid: 201)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {googleCalendarDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - is timetable selected - for weekly layout only
 * @property {boolean} wixlabs_bool_3 - selected time format (true = 12 / false = 24)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_7 - In Monthly: cell resize -  1_on_1_ratio / flexible_ratio, in agenda - null
 * @property {string} wixlabs_string_4 - selected language
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {string} wixlabs_string_3 - days to display
 * @property {string} wixlabs_string_8 - In Agenda: - calendar hight - fit_to_content / fixed_size, in monthly - null
 * @property {boolean} wixlabs_bool_4 - show time zone toggle
 * @property {boolean} wixlabs_bool_6 - show private events toggle
 * @property {boolean} wixlabs_bool_1 - is_connected to google account
 * @property {string} wixlabs_string_9 - in monthly: selected alignment - left / center ,in Agenda - null
 * @property {string} wixlabs_string_2 - week starts on
 * @property {boolean} wixlabs_bool_7 - colors - true = site colors / false = google calendar colors
 * @property {number} wixlabs_num_2 - number of calendars options in the account
 * @property {boolean} wixlabs_bool_5 - show start time toggle - only in monthly, in agenda null
 * @property {string} wixlabs_string_5 - show private events as - private / custom_string
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - number of calendars displayed
 * @property {string} wixlabs_string_1 - selected layout type - Monthly / Agenda / Weekly
 * @property {string} instance_id - instance_id
 * @property {string} wixlabs_string_6 - selected time zone - visitor_location / custom_time_zone
 * @return {LogObject<googleCalendarDetailsParams>} LogObject<googleCalendarDetailsParams>
 */
export function googleCalendarDetails(params) {
    return { evid: 201, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFilesToDropboxDetails' event (evid: 202)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {getFilesToDropboxDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - did select a folder
 * @property {boolean} wixlabs_bool_3 - create sub-folder
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {string} wixlabs_string_3 - selected language
 * @property {boolean} wixlabs_bool_4 - send email
 * @property {boolean} wixlabs_bool_1 - is_connected to google account
 * @property {string} wixlabs_string_2 - selected layout type
 * @property {number} wixlabs_num_2 - disable storage when
 * @property {boolean} wixlabs_bool_5 - add message
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - max size per upload
 * @property {string} wixlabs_string_1 - upload requires
 * @property {string} instance_id - instance_id
 * @return {LogObject<getFilesToDropboxDetailsParams>} LogObject<getFilesToDropboxDetailsParams>
 */
export function getFilesToDropboxDetails(params) {
    return { evid: 202, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'holidayBadgesDetails' event (evid: 203)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {holidayBadgesDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {string} wixlabs_string_2 - when click
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - selected badge name
 * @property {string} instance_id - instance_id
 * @return {LogObject<holidayBadgesDetailsParams>} LogObject<holidayBadgesDetailsParams>
 */
export function holidayBadgesDetails(params) {
    return { evid: 203, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixWeatherDetails' event (evid: 204)
 *
 * Event description: Sending all the relevant app settings at publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {wixWeatherDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - temperature (true = c, false = f)
 * @property {boolean} wixlabs_bool_3 - show c/f selector
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_4 - selected icon set
 * @property {string} event_trigger - {'publish'} - only in publish
 * @property {string} wixlabs_string_3 - selected bg scene
 * @property {boolean} wixlabs_bool_4 - show details
 * @property {boolean} wixlabs_bool_6 - Ticker Layout (true = Horizontal; False = Vertical)
 * @property {boolean} wixlabs_bool_1 - uses different display name
 * @property {string} wixlabs_string_2 - selected language
 * @property {boolean} wixlabs_bool_5 - Layout (true = widget; False = ticker)
 * @property {string} wixlabs_string_5 - selected animation
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - selected forecast
 * @property {string} instance_id - instance_id
 * @property {string} wixlabs_string_6 - Ticker - Alignment (Horizontal layout - left / center/ right ; Verticsl layout - top / center / bottom)
 * @return {LogObject<wixWeatherDetailsParams>} LogObject<wixWeatherDetailsParams>
 */
export function wixWeatherDetails(params) {
    return { evid: 204, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixFaqDetails' event (evid: 205)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {wixFaqDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_13 - enable SEO  (Toggle On = true, Toggle Off = false)
 * @property {number} wixlabs_num_4 - number of videos
 * @property {boolean} wixlabs_bool_14 - Expand Icon - true = Arrow, false = Plus
 * @property {boolean} wixlabs_bool_2 - show search bar
 * @property {boolean} wixlabs_bool_3 - show social icons
 * @property {boolean} wixlabs_bool_9 - show demo data
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - number of images
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {boolean} wixlabs_bool_12 - app spacing true = regular, false = compact
 * @property {boolean} wixlabs_bool_4 - open first answer
 * @property {boolean} wixlabs_bool_6 - alignment (True = Left; False = right)
 * @property {boolean} wixlabs_bool_10 - show all categories (Toggle On = true, Toggle Off = false)
 * @property {boolean} wixlabs_bool_1 - show title
 * @property {string} wixlabs_string_2 - Title alignment =  left / center / right
 * @property {boolean} wixlabs_bool_11 - show one answer at atime  (Toggle On = true, Toggle Off = false)
 * @property {boolean} wixlabs_bool_7 - hovered over the "mobile view" in desktop main tab
 * @property {number} wixlabs_num_2 - number of categories
 * @property {boolean} wixlabs_bool_5 - app height (True = auto fit ; False = set to size)
 * @property {number} wixlabs_num_5 - number of categories chosen
 * @property {boolean} wixlabs_bool_8 - opened mobile settings
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - number of questions
 * @property {string} wixlabs_string_1 - selected layout
 * @property {string} instance_id - instance_id
 * @return {LogObject<wixFaqDetailsParams>} LogObject<wixFaqDetailsParams>
 */
export function wixFaqDetails(params) {
    return { evid: 205, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bloggerDetails' event (evid: 207)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {bloggerDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {number} wixlabs_num_4 - # of blogs
 * @property {boolean} wixlabs_bool_2 - opened_dashboard
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - # of posts (in the selected blog)
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {boolean} wixlabs_bool_1 - is_connected
 * @property {number} wixlabs_num_2 - number of columns
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - number of rows
 * @property {string} wixlabs_string_1 - selected layout
 * @property {string} instance_id - instance_id
 * @return {LogObject<bloggerDetailsParams>} LogObject<bloggerDetailsParams>
 */
export function bloggerDetails(params) {
    return { evid: 207, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tumblerDetails' event (evid: 208)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {tumblerDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {number} wixlabs_num_4 - number of blogs
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - number of posts
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {boolean} wixlabs_bool_1 - is_connected
 * @property {number} wixlabs_num_2 - number of columns
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - number of rows
 * @property {string} wixlabs_string_1 - selected layout
 * @property {string} instance_id - instance_id
 * @return {LogObject<tumblerDetailsParams>} LogObject<tumblerDetailsParams>
 */
export function tumblerDetails(params) {
    return { evid: 208, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'imagesDetails' event (evid: 209)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {imagesDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - quality (false = standard ; true = stereophonic)
 * @property {boolean} wixlabs_bool_3 - image_ratio
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {boolean} wixlabs_bool_1 - full_screen
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - selected image (demo image name / user images)
 * @property {string} instance_id - instance_id
 * @return {LogObject<imagesDetailsParams>} LogObject<imagesDetailsParams>
 */
export function imagesDetails(params) {
    return { evid: 209, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'textBoxChange' event (evid: 21)
 *
 * Event description: when user clicking "Enter" or outside the text box, after changing the text
 *
 * @param {textBoxChangeParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {string} sub_tab - sub_tab : "categories","home_page"
 * @property {string} market - {editor,dashboard}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} tab_name - {select_language. language_redirection, language_switcher...}
 * @property {string} origin - {app_settings, widget, app_bo}
 * @property {GUID} app_id - app_id
 * @property {string} text_box - {category title, category des,.....}
 * @property {string} instance_id - instance_id
 * @property {string} text_input - {my forum, my new text.....}
 * @return {LogObject<textBoxChangeParams>} LogObject<textBoxChangeParams>
 */
export function textBoxChange(params) {
    return { evid: 21, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dropboxFolderDetails' event (evid: 210)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {dropboxFolderDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - show title (settings)
 * @property {boolean} wixlabs_bool_3 - show number of items (settings)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {string} wixlabs_string_3 - icon size (design)
 * @property {boolean} wixlabs_bool_4 - show icons (settings)
 * @property {boolean} wixlabs_bool_1 - is_connected
 * @property {string} wixlabs_string_2 - icon style (design)
 * @property {boolean} wixlabs_bool_5 - Does the widget display folders
 * @property {number} wixlabs_int_1 - number of items in the first window
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - selected layout
 * @property {string} instance_id - instance_id
 * @return {LogObject<dropboxFolderDetailsParams>} LogObject<dropboxFolderDetailsParams>
 */
export function dropboxFolderDetails(params) {
    return { evid: 210, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'cookieAlertDetails' event (evid: 211)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {cookieAlertDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {string} wixlabs_string_2 - selected alignment
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - selected layout
 * @property {string} instance_id - instance_id
 * @return {LogObject<cookieAlertDetailsParams>} LogObject<cookieAlertDetailsParams>
 */
export function cookieAlertDetails(params) {
    return { evid: 211, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'amazonDetails' event (evid: 212)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {amazonDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - If "show price and prime" is enabled
 * @property {boolean} wixlabs_bool_3 - Empty
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - Total number of  added variation items (in colors)
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {boolean} wixlabs_bool_4 - Empty
 * @property {boolean} wixlabs_bool_1 - Affiliate is/ not connected
 * @property {string} wixlabs_string_2 - Domains of added items (if not connected).
 * @property {number} wixlabs_num_2 - Total number of added items
 * @property {boolean} wixlabs_bool_5 - Is full width
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - How many items per row
 * @property {string} wixlabs_string_1 - Which domain affiliate is connected to (if connected)
 * @property {string} instance_id - instance_id
 * @return {LogObject<amazonDetailsParams>} LogObject<amazonDetailsParams>
 */
export function amazonDetails(params) {
    return { evid: 212, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'countdownDetails' event (evid: 213)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {countdownDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - display days
 * @property {boolean} wixlabs_bool_3 - display seconds
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {boolean} wixlabs_bool_4 - display days
 * @property {boolean} wixlabs_bool_1 - counter style (true - 1, false - 2)
 * @property {number} wixlabs_num_2 - hours to count over
 * @property {boolean} wixlabs_bool_5 - display seconds
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - hours to count
 * @property {string} wixlabs_string_1 - when completed (nothing ; message)
 * @property {string} instance_id - instance_id
 * @return {LogObject<countdownDetailsParams>} LogObject<countdownDetailsParams>
 */
export function countdownDetails(params) {
    return { evid: 213, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hitCounterDetails' event (evid: 214)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {hitCounterDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - Animation (true - any animation, false - no animation)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {number} wixlabs_int_2 - Set start number
 * @property {boolean} wixlabs_bool_1 - Count (true - All, false - Unique)
 * @property {number} wixlabs_int_1 - Selected Layout
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<hitCounterDetailsParams>} LogObject<hitCounterDetailsParams>
 */
export function hitCounterDetails(params) {
    return { evid: 214, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramfeedLinkDetails' event (evid: 215)
 *
 * Event description: instagramfeed_link_details
 *
 * @param {instagramfeedLinkDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {number} wixlabs_num_4 - num of Product links
 * @property {boolean} wixlabs_bool_2 - Auto sync on / off = true / false
 * @property {boolean} wixlabs_bool_3 - Get started (True - clicked 'get started', False - didn't)
 * @property {number} wixlabs_num_7 - num of Page links
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - num of synced links
 * @property {boolean} wixlabs_bool_1 - has Wix store = true / false
 * @property {number} wixlabs_num_2 - num of links
 * @property {number} wixlabs_num_5 - num of product links with hidden price
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - num of linked posts
 * @property {number} wixlabs_num_6 - num of web links
 * @property {string} instance_id - instance_id
 * @return {LogObject<instagramfeedLinkDetailsParams>} LogObject<instagramfeedLinkDetailsParams>
 */
export function instagramfeedLinkDetails(params) {
    return { evid: 215, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pdfDetails' event (evid: 216)
 *
 * Event description: pdf_details
 *
 * @param {pdfDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - full viewer - allow to download = true / false (false if layout != full)
 * @property {boolean} wixlabs_bool_3 - full viewer - allow to print = true / false (false if layout != full)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save','publish'}
 * @property {boolean} wixlabs_bool_1 - Selected file = true / false
 * @property {string} settings_details - json converted to string
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - which page is displayd / displayed first
 * @property {string} wixlabs_string_1 - Selected layout = mini / full / one / thumb
 * @property {string} instance_id - instance_id
 * @return {LogObject<pdfDetailsParams>} LogObject<pdfDetailsParams>
 */
export function pdfDetails(params) {
    return { evid: 216, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleDocsDetails' event (evid: 217)
 *
 * Event description: google_docs_details
 *
 * @param {googleDocsDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save','publish'}
 * @property {boolean} wixlabs_bool_1 - is_connected
 * @property {string} wixlabs_string_2 - Privacy of the file:  Read only/Editable. If not selected, send null
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - Type of file. If not selected, send null
 * @property {string} instance_id - instance_id
 * @return {LogObject<googleDocsDetailsParams>} LogObject<googleDocsDetailsParams>
 */
export function googleDocsDetails(params) {
    return { evid: 217, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'yelpDetails' event (evid: 218)
 *
 * Event description: yelp_details
 *
 * @param {yelpDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - show star rating
 * @property {boolean} wixlabs_bool_3 - show reviews
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - publish
 * @property {boolean} wixlabs_bool_4 - layout (true = white / False = red)
 * @property {boolean} wixlabs_bool_1 - is_connected
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - image (None / Round / Square)
 * @property {string} instance_id - instance_id
 * @return {LogObject<yelpDetailsParams>} LogObject<yelpDetailsParams>
 */
export function yelpDetails(params) {
    return { evid: 218, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'backToTopDetails' event (evid: 219)
 *
 * Event description: back_to_top_details
 *
 * @param {backToTopDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_4 - ver position (Top / Middle / Bottom)
 * @property {string} event_trigger - {'save','publish'}
 * @property {string} wixlabs_string_3 - icon design (1 / 2 / 3)
 * @property {boolean} wixlabs_bool_1 - show on all pages
 * @property {string} wixlabs_string_2 - icon style (icon + text / icon / text)
 * @property {string} wixlabs_string_1 - size (S / M / L)
 * @property {string} instance_id - instance_id
 * @return {LogObject<backToTopDetailsParams>} LogObject<backToTopDetailsParams>
 */
export function backToTopDetails(params) {
    return { evid: 219, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'amazonConnectionError' event (evid: 22)
 *
 * Event description: User get connection error
 *
 * @param {amazonConnectionErrorParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} instanceId - instance_id
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_4 - secretAccessKey
 * @property {string} wixlabs_string_3 - domain
 * @property {number} error_id - error_id
 * @property {string} wixlabs_string_2 - associateTag
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - accessKeyId
 * @property {string} instance_id - instance_id
 * @return {LogObject<amazonConnectionErrorParams>} LogObject<amazonConnectionErrorParams>
 */
export function amazonConnectionError(params) {
    return { evid: 22, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tableMasterDetails' event (evid: 220)
 *
 * Event description: Table_master_details when user publishes
 *
 * @param {tableMasterDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - Show header/footer
 * @property {boolean} wixlabs_bool_3 - Search
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_4 - Alignment (Right / Center / Left)
 * @property {string} event_trigger - {'save'}
 * @property {string} wixlabs_string_3 - App height (Fixed / According to content)
 * @property {boolean} wixlabs_bool_4 - Allow Sorting
 * @property {boolean} wixlabs_bool_1 - Date was submitted (The user added content to the table or a spreadsheet link, and clicked on 'submit'. No errors)
 * @property {string} wixlabs_string_2 - Mobile view (Expand / Scroll)
 * @property {number} wixlabs_num_1 - Limit columns to display (if selected, else - return 0)
 * @property {string} wixlabs_string_1 - Data Source (Manually / Spreadsheet)
 * @property {string} instance_id - instance_id
 * @return {LogObject<tableMasterDetailsParams>} LogObject<tableMasterDetailsParams>
 */
export function tableMasterDetails(params) {
    return { evid: 220, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'getFundingDetails' event (evid: 221)
 *
 * Event description: get_funding_details
 *
 * @param {getFundingDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {number} wixlabs_num_4 - original left days (first time)
 * @property {boolean} wixlabs_bool_2 - Show how many people have donated
 * @property {boolean} wixlabs_bool_3 - Show how much money has been donated
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - goal (null if not selected)
 * @property {string} event_trigger - publish
 * @property {string} wixlabs_string_3 - font size (small,medium,large)
 * @property {boolean} wixlabs_bool_4 - show progress bar
 * @property {boolean} wixlabs_bool_6 - show social sharing icons
 * @property {boolean} wixlabs_bool_1 - Is Connected to PayPal
 * @property {string} wixlabs_string_2 - currency
 * @property {number} wixlabs_num_2 - minimum amount
 * @property {boolean} wixlabs_bool_5 - show time frame
 * @property {number} wixlabs_num_1 - default amount
 * @property {string} wixlabs_string_1 - media type (image,video)
 * @property {string} instance_id - instance_id
 * @return {LogObject<getFundingDetailsParams>} LogObject<getFundingDetailsParams>
 */
export function getFundingDetails(params) {
    return { evid: 221, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'giftCardDetails' event (evid: 225)
 *
 * Event description: gift_card_details
 *
 * @param {giftCardDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - logo is added
 * @property {boolean} wixlabs_bool_3 - QR is added
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - max amount
 * @property {string} event_trigger - publish
 * @property {string} wixlabs_string_3 - email language
 * @property {boolean} wixlabs_bool_1 - is connected to paypal
 * @property {string} wixlabs_string_2 - validation period (not limited, 3 month, 6 month)
 * @property {number} wixlabs_num_2 - min amount
 * @property {number} wixlabs_num_1 - default amount
 * @property {string} wixlabs_string_1 - currency
 * @property {string} instance_id - instance_id
 * @return {LogObject<giftCardDetailsParams>} LogObject<giftCardDetailsParams>
 */
export function giftCardDetails(params) {
    return { evid: 225, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'slidesahreDetails' event (evid: 226)
 *
 * Event description: slidesahre_details
 *
 * @param {slidesahreDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {boolean} wixlabs_bool_1 - linked a ppt
 * @property {string} instance_id - instance_id
 * @return {LogObject<slidesahreDetailsParams>} LogObject<slidesahreDetailsParams>
 */
export function slidesahreDetails(params) {
    return { evid: 226, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'pinterestFeedDetails' event (evid: 227)
 *
 * Event description: Pinterest_Feed_details, summary event for pintrest sent when publishing the site
 *
 * @param {pinterestFeedDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - is showing recent pins = true / false
 * @property {boolean} wixlabs_bool_3 - is showing pin discription = true / false
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {boolean} wixlabs_bool_4 - is full width = true / false
 * @property {boolean} wixlabs_bool_6 - opened mobile settings
 * @property {boolean} wixlabs_bool_1 - is connected = true / false
 * @property {string} wixlabs_string_2 - mobile autofit/fixed
 * @property {boolean} wixlabs_bool_5 - hovered over the "mobile view" in desktop main tab
 * @property {GUID} app_id - app_id
 * @property {string} wixlabs_string_1 - desktop autofit/fixed
 * @property {string} instance_id - instance_id
 * @return {LogObject<pinterestFeedDetailsParams>} LogObject<pinterestFeedDetailsParams>
 */
export function pinterestFeedDetails(params) {
    return { evid: 227, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deviantArtDetails' event (evid: 228)
 *
 * Event description: deviant_art_details, summary event for deviant_art sent when publishing the site
 *
 * @param {deviantArtDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {boolean} wixlabs_bool_13 - Popup - show views
 * @property {boolean} wixlabs_bool_14 - Popup - show download
 * @property {boolean} wixlabs_bool_2 - full widht selected
 * @property {boolean} wixlabs_bool_3 - Desktop - show more button displayed
 * @property {boolean} wixlabs_bool_9 - Desktop - showing username and avatar
 * @property {GUID} site_id - ----- DEPRECATED ----- send empty
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - Mobile - number of rows
 * @property {boolean} wixlabs_bool_12 - Mobile - showing DA logo
 * @property {boolean} wixlabs_bool_4 - Mobile - show more button displayed
 * @property {boolean} wixlabs_bool_6 - showing featured (Ture if ALL deviations is True)
 * @property {boolean} wixlabs_bool_10 - Desktop - showing DA logo
 * @property {boolean} wixlabs_bool_1 - connected to DA
 * @property {boolean} wixlabs_bool_11 - Mobile - showing username and avatar
 * @property {boolean} wixlabs_bool_7 - showing ALL folders (Ture if ALL deviations is True)
 * @property {number} wixlabs_num_2 - Desktop - number of rows
 * @property {boolean} wixlabs_bool_5 - showing ALL deviations
 * @property {boolean} wixlabs_bool_8 - Enable pop-up = true / false
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - number of folders displayed
 * @property {string} wixlabs_string_1 - selected language
 * @property {string} instance_id - comp_id
 * @return {LogObject<deviantArtDetailsParams>} LogObject<deviantArtDetailsParams>
 */
export function deviantArtDetails(params) {
    return { evid: 228, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedAdi' event (evid: 229)
 *
 * Event description: instagram feed details for ADI, summary event sent when publishing the site
 *
 * @param {instagramFeedAdiParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - full width selected
 * @property {boolean} wixlabs_bool_3 - selected STYLE # - is full with selected - true / false
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {boolean} wixlabs_bool_4 - show more button displayed - true / false
 * @property {boolean} wixlabs_bool_1 - connected account {T,F}
 * @property {boolean} wixlabs_bool_5 - Pop-up displayed - true / false
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - selected STYLE #
 * @property {string} wixlabs_string_1 - selected STYLE # layout (Grid / Slider / Collage)
 * @property {string} instance_id - instance_id
 * @return {LogObject<instagramFeedAdiParams>} LogObject<instagramFeedAdiParams>
 */
export function instagramFeedAdi(params) {
    return { evid: 229, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'yandexMapsDetails' event (evid: 230)
 *
 * Event description: Yandex Maps details, summary event sent when publishing the site
 *
 * @param {yandexMapsDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - Allow to drag map {T,F}
 * @property {boolean} wixlabs_bool_3 - Allow control map type {T,F}
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_3 - Map language =  English / Turkish / Russian
 * @property {boolean} wixlabs_bool_4 - Allow zoom in {T,F}
 * @property {boolean} wixlabs_bool_6 - Show description on hover {T,F}
 * @property {boolean} wixlabs_bool_1 - Show location details {T,F}
 * @property {string} wixlabs_string_2 - Show locations  =  show first / show all
 * @property {boolean} wixlabs_bool_5 - Show name on hover {T,F}
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - Number of added locations
 * @property {string} wixlabs_string_1 - Map type =  map / satellite / hybrid
 * @property {string} instance_id - instance_id
 * @return {LogObject<yandexMapsDetailsParams>} LogObject<yandexMapsDetailsParams>
 */
export function yandexMapsDetails(params) {
    return { evid: 230, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'okClassButtonDetails' event (evid: 231)
 *
 * Event description: ok class button details, summary event sent when publishing the site
 *
 * @param {okClassButtonDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {boolean} wixlabs_bool_2 - show counter button displayed = true/false (bool)
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} wixlabs_string_4 - Counter position = inside, above (string)
 * @property {string} wixlabs_string_3 - Text description = class, share, like (string)
 * @property {boolean} wixlabs_bool_1 - Show text  button displayed = true/false (bool)
 * @property {string} wixlabs_string_2 - Size = small, medium, large  (string)
 * @property {string} wixlabs_string_1 - Button_shape = round, rounded, square (string)
 * @property {string} instance_id - instance_id
 * @return {LogObject<okClassButtonDetailsParams>} LogObject<okClassButtonDetailsParams>
 */
export function okClassButtonDetails(params) {
    return { evid: 231, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareYourMobilePlaceDetails' event (evid: 233)
 *
 * Event description: Share Your Mobile Place details, summary event sent when publishing the site.
 *
 * @param {shareYourMobilePlaceDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {boolean} description_text - if the option is on / off
 * @property {boolean} app_preview - true/false
 * @property {boolean} default_title - true = published with the default text / false = changed the default text
 * @property {string} input_field - box / line
 * @property {GUID} biToken - msid
 * @property {string} language_selected - language selected
 * @property {boolean} scan_qr - true/false
 * @property {boolean} app_title - true/false
 * @property {string} instance_Id - instance_id
 * @property {boolean} phone_image - if the image is on / off (if app_form is strip then null)
 * @property {boolean} sms_invite - if the option is on / off
 * @property {string} app_form - box / strip
 * @property {boolean} display_title - if the option is on / off
 * @property {boolean} default_description - true = published with the default text / false = changed the default text
 * @property {boolean} app_store_icons - if the option is on / off
 * @property {string} type - spaces / fit
 * @property {string} phone_outline - white / black (if app_form is strip or phone_image = false then null)
 * @property {boolean} default_send - true = published with the default text / false = changed the default text
 * @property {string} instance_id - instance_id
 * @property {boolean} default_phone_number - true = published with the default text / false = changed the default text
 * @property {string} presetName - preset name
 * @return {LogObject<shareYourMobilePlaceDetailsParams>} LogObject<shareYourMobilePlaceDetailsParams>
 */
export function shareYourMobilePlaceDetails(params) {
    return { evid: 233, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'etsy20Details' event (evid: 234)
 *
 * Event description: When the user publish the sites.
 *
 * @param {etsy20DetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {string} arrange_by - Most Recent / Relevance / Highest Price / Loweat Price
 * @property {boolean} is_header - Is header display (True/False)
 * @property {GUID} biToken - msid
 * @property {boolean} is_connected - Is connected to Etsy (True/False)
 * @property {boolean} is_search_bar - Is search bar display (True/False)
 * @property {boolean} is_section_list - Is section list display (True/False)
 * @property {boolean} is_sort_menu - Is sort menu display (True/False)
 * @property {string} instance_id - comp id
 * @property {number} number_of_items - how many items in the shop (not including demo items)
 * @return {LogObject<etsy20DetailsParams>} LogObject<etsy20DetailsParams>
 */
export function etsy20Details(params) {
    return { evid: 234, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'error' event (evid: 25)
 *
 * Event description: Connection error
 * In Instagram - when the user see the message "can't load IG, please try again later"
 *
 * @param {errorParams} params - The parameters for this event
 * @property {GUID} app_site_id - real instance_id
 * @property {string} instanceId - real comp_id
 * @property {GUID} biToken - msid
 * @property {string} description - error description
 * @property {number} error_id - error_id
 * @property {string} api_description - api error description
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - error type
 * @property {string} instance_id - real comp_id
 * @return {LogObject<errorParams>} LogObject<errorParams>
 */
export function error(params) {
    return { evid: 25, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fsHeaderButtonClickSrc63Evid26' event (evid: 26)
 *
 * Event description: FS: header button click
 *
 * @param {fsHeaderButtonClickSrc63Evid26Params} params - The parameters for this event
 * @property {string} button_name - button name
 * @return {LogObject<fsHeaderButtonClickSrc63Evid26Params>} LogObject<fsHeaderButtonClickSrc63Evid26Params>
 */
export function fsHeaderButtonClickSrc63Evid26(params) {
    return { evid: 26, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedWidgetAddedSrc63Evid28' event (evid: 28)
 *
 * Event description: Send when the widget was added
 *
 * @param {instagramFeedWidgetAddedSrc63Evid28Params} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} source - install/add_panel
 * @return {LogObject<instagramFeedWidgetAddedSrc63Evid28Params>} LogObject<instagramFeedWidgetAddedSrc63Evid28Params>
 */
export function instagramFeedWidgetAddedSrc63Evid28(params) {
    return { evid: 28, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resultsButtonClickSrc63Evid3' event (evid: 3)
 *
 * Event description: Working with text actions
 *
 * @param {resultsButtonClickSrc63Evid3Params} params - The parameters for this event
 * @property {string} button_name - Action button: use_text, refine_results
 * @property {string} option - Text result: 1, 2, 3
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @return {LogObject<resultsButtonClickSrc63Evid3Params>} LogObject<resultsButtonClickSrc63Evid3Params>
 */
export function resultsButtonClickSrc63Evid3(params) {
    return { evid: 3, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uploadFileAppsFileUploaded' event (evid: 300)
 *
 * Event description: after trying to load a file in dropbox app. the filed message will show success or fail
 *
 * @param {uploadFileAppsFileUploadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} file_names - file_names (json)
 * @property {string} size - file_size_total
 * @property {string} email - sender_email
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {Url} go_to_my_folder_link - go_to_my_folder_link
 * @property {Url} go_to_app_link - go_to_app_link
 * @property {string} message - free_text_message (success/fail)
 * @property {string} comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<uploadFileAppsFileUploadedParams>} LogObject<uploadFileAppsFileUploadedParams>
 */
export function uploadFileAppsFileUploaded(params) {
    return { evid: 300, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnButtonOrLink' event (evid: 301)
 *
 * Event description: Site Visitors click on app's button/link
 *
 * @param {clickOnButtonOrLinkParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} description - If product -> product ID ;  If web -> web address ;  If page -> empty
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {number} position - position of link in the instagram post
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - {product / web / page / native / none}
 * @return {LogObject<clickOnButtonOrLinkParams>} LogObject<clickOnButtonOrLinkParams>
 */
export function clickOnButtonOrLink(params) {
    return { evid: 301, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'statusChange' event (evid: 302)
 *
 * Event description: app change status
 *
 * @param {statusChangeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} old_status - {connected, disconnected, activated...}
 * @property {GUID} biToken - msid
 * @property {string} description - description
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {string} new_status - {connected, disconnected, activated...}
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - {connect_account, feature_activation...}
 * @return {LogObject<statusChangeParams>} LogObject<statusChangeParams>
 */
export function statusChange(params) {
    return { evid: 302, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'messageDisplayed' event (evid: 303)
 *
 * Event description: message displayed to site visitor
 *
 * @param {messageDisplayedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} msg_type - {error, notification}
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {string} msg_desc - {welcome, finish_set_up, 'name already exists', 'API not available'...}
 * @property {string} comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<messageDisplayedParams>} LogObject<messageDisplayedParams>
 */
export function messageDisplayed(params) {
    return { evid: 303, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramViewPost' event (evid: 304)
 *
 * Event description: event is triggered when UoU is entering an instagram post
 *
 * @param {instagramViewPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} wixlabs_bool_2 - link2 has image (not place holder) = true / false
 * @property {boolean} wixlabs_bool_3 - link3 has image (not place holder) = true / false
 * @property {string} product_1 - Product id 1 (if link1 = product)
 * @property {string} app_type - app type
 * @property {string} link_1 - shows the type of link (product / web / page / native / none)
 * @property {GUID} biToken - msid
 * @property {string} link_2 - shows the type of link (product / web / page / native / none)
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {string} account_type - account type
 * @property {boolean} wixlabs_bool_1 - link1 has image (not place holder) = true / false
 * @property {string} link_3 - shows the type of link (product / web / page / native / none)
 * @property {string} product_3 - Product id 3 (if link3 = product)
 * @property {string} product_2 - Product id 2 (if link2 = product)
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - photo / video / igtv
 * @property {string} gallery_type - posts_feed  / hashtag_feed
 * @return {LogObject<instagramViewPostParams>} LogObject<instagramViewPostParams>
 */
export function instagramViewPost(params) {
    return { evid: 304, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewDeviation' event (evid: 305)
 *
 * Event description: event is triggered when UoU
 *
 * @param {viewDeviationParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {boolean} buy_button - is displaying 'buy' button
 * @property {string} comp_id - reflects instance_id in Editor events
 * @property {GUID} app_id - app_id
 * @property {string} type - desktop / mobile
 * @return {LogObject<viewDeviationParams>} LogObject<viewDeviationParams>
 */
export function viewDeviation(params) {
    return { evid: 305, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'donationWasDone' event (evid: 306)
 *
 * Event description: When user clicks on "donate" button
 *
 * @param {donationWasDoneParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} wixlabs_num_3 - Days Left
 * @property {GUID} visitor_id - visitor_id
 * @property {number} wixlabs_num_2 - Donated
 * @property {number} position - send the "amount"
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - Contributors
 * @property {string} type - Mobile / Desktop
 * @return {LogObject<donationWasDoneParams>} LogObject<donationWasDoneParams>
 */
export function donationWasDone(params) {
    return { evid: 306, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedAppLoads' event (evid: 307)
 *
 * Event description: Send when the app loads.
 *
 * @param {instagramFeedAppLoadsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} source - source
 * @property {string} app_type - app type
 * @property {GUID} app_site_id - instance id
 * @property {GUID} biToken - msid
 * @property {string} description - docker1 / docker2
 * @property {number} followers_count - num of followers in Instagram
 * @property {GUID} visitor_id - visitor_id
 * @property {string} account_type - account type
 * @property {string} user_id - instagram user id (if not connected, null)
 * @property {string} api_description - api error description
 * @property {number} num_of_columns - number of photos in each row in desktop (Editor and ADI)
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} layout - desktop layout - grid / collage / slider (Editor and ADI)
 * @property {string} type - type of instagram account (business / private / demo - didn't connect)
 * @property {number} num_of_rows - number of rows in desktop (Editor and ADI)
 * @return {LogObject<instagramFeedAppLoadsParams>} LogObject<instagramFeedAppLoadsParams>
 */
export function instagramFeedAppLoads(params) {
    return { evid: 307, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleDriveSelectFileOrFolder' event (evid: 308)
 *
 * Event description: File or folder was picked
 *
 * @param {googleDriveSelectFileOrFolderParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} old_status - empty
 * @property {string} market - editor
 * @property {GUID} biToken - msid
 * @property {string} tab_name - empty
 * @property {string} new_status - connected
 * @property {string} origin - app_settings
 * @property {string} type - File / Folder
 * @property {string} instance_id - comp_id
 * @return {LogObject<googleDriveSelectFileOrFolderParams>} LogObject<googleDriveSelectFileOrFolderParams>
 */
export function googleDriveSelectFileOrFolder(params) {
    return { evid: 308, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'addBadge' event (evid: 309)
 *
 * Event description: User add a badge
 *
 * @param {addBadgeParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} instance_Id - instance_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<addBadgeParams>} LogObject<addBadgeParams>
 */
export function addBadge(params) {
    return { evid: 309, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareYourMobilePlaceClickOnButton' event (evid: 310)
 *
 * Event description: When UoU clicks on one of the buttons in the app.
 *
 * @param {shareYourMobilePlaceClickOnButtonParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} country_number - The country code of the phone number
 * @property {string} button_description - send / send again / app store / google play
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} app_form - box / strip
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - spaces / fit
 * @return {LogObject<shareYourMobilePlaceClickOnButtonParams>} LogObject<shareYourMobilePlaceClickOnButtonParams>
 */
export function shareYourMobilePlaceClickOnButton(params) {
    return { evid: 310, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'shareYourMobilePlaceError' event (evid: 311)
 *
 * Event description: UoU gets an error.
 *
 * @param {shareYourMobilePlaceErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} error_type - invalid number / API
 * @property {string} app_form - box / strip
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - spaces / fit
 * @return {LogObject<shareYourMobilePlaceErrorParams>} LogObject<shareYourMobilePlaceErrorParams>
 */
export function shareYourMobilePlaceError(params) {
    return { evid: 311, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sympAppLoaded' event (evid: 312)
 *
 * Event description: event triggered when the app is viewed in the live site.
 *
 * @param {sympAppLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} app_form - box / strip
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - which mobile app - spaces / fit
 * @return {LogObject<sympAppLoadedParams>} LogObject<sympAppLoadedParams>
 */
export function sympAppLoaded(params) {
    return { evid: 312, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hoveringOverPost' event (evid: 313)
 *
 * Event description: Site Visitors hover over post
 *
 * @param {hoveringOverPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} app_type - app type
 * @property {GUID} biToken - msid
 * @property {string} description - description
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {string} account_type - account type
 * @property {number} position - the position of the post in the feed
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - {product / web / page / native / none}
 * @property {string} gallery_type - posts_feed / hashtag_feed
 * @return {LogObject<hoveringOverPostParams>} LogObject<hoveringOverPostParams>
 */
export function hoveringOverPost(params) {
    return { evid: 313, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedError' event (evid: 314)
 *
 * Event description: Instagram Errors in Live Site
 *
 * @param {instagramFeedErrorParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} app_type - app type
 * @property {GUID} biToken - msid
 * @property {string} description - error description
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {string} account_type - account type
 * @property {string} api_description - api error description
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - error type
 * @return {LogObject<instagramFeedErrorParams>} LogObject<instagramFeedErrorParams>
 */
export function instagramFeedError(params) {
    return { evid: 314, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedViewStory' event (evid: 315)
 *
 * Event description: event for each story separately
 *
 * @param {instagramFeedViewStoryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} app_type - app type
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - get this ID from the signed instance using Wix.Utils.getInstanceValue('aid')
 * @property {string} account_type - account type
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - video / image
 * @return {LogObject<instagramFeedViewStoryParams>} LogObject<instagramFeedViewStoryParams>
 */
export function instagramFeedViewStory(params) {
    return { evid: 315, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedAppLoadsStartLoading' event (evid: 317)
 *
 * Event description: Send when the app loads.
 *
 * @param {instagramFeedAppLoadsStartLoadingParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} app_site_id - deprecated
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<instagramFeedAppLoadsStartLoadingParams>} LogObject<instagramFeedAppLoadsStartLoadingParams>
 */
export function instagramFeedAppLoadsStartLoading(params) {
    return { evid: 317, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedCronJobTryYoRefreshToken' event (evid: 318)
 *
 * Event description: when we try to refresh the token
 *
 * @param {instagramFeedCronJobTryYoRefreshTokenParams} params - The parameters for this event
 * @property {GUID} app_site_id - real instance_id
 * @property {GUID} biToken - msid
 * @property {string} origin - server / ''
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - real comp_id
 * @return {LogObject<instagramFeedCronJobTryYoRefreshTokenParams>} LogObject<instagramFeedCronJobTryYoRefreshTokenParams>
 */
export function instagramFeedCronJobTryYoRefreshToken(params) {
    return { evid: 318, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedCronJobRefreshTokenStatusChanged' event (evid: 319)
 *
 * Event description: when we try to refresh the token
 *
 * @param {instagramFeedCronJobRefreshTokenStatusChangedParams} params - The parameters for this event
 * @property {GUID} app_site_id - real instance_id
 * @property {GUID} biToken - msid
 * @property {string} new_status - success / fail
 * @property {string} origin - server / ''
 * @property {string} error_description - error description
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - when fail: user side (error code 190) / server side (not error code 190)
 * @property {string} instance_id - real comp_id
 * @property {DateTime} expiry_date - for sucess - new expiry date
 * @return {LogObject<instagramFeedCronJobRefreshTokenStatusChangedParams>} LogObject<instagramFeedCronJobRefreshTokenStatusChangedParams>
 */
export function instagramFeedCronJobRefreshTokenStatusChanged(params) {
    return { evid: 319, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'instagramFeedCronJobStartHourlyDailyProcess' event (evid: 320)
 *
 * Event description: when the cron job starts running - hourly/daily basis.
 *
 * @param {instagramFeedCronJobStartHourlyDailyProcessParams} params - The parameters for this event
 * @property {GUID} app_site_id - real instance_id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - hourly / daily
 * @property {string} instance_id - real comp_id
 * @return {LogObject<instagramFeedCronJobStartHourlyDailyProcessParams>} LogObject<instagramFeedCronJobStartHourlyDailyProcessParams>
 */
export function instagramFeedCronJobStartHourlyDailyProcess(params) {
    return { evid: 320, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'etsy20SortBy' event (evid: 350)
 *
 * Event description: User or UoU sort by
 *
 * @param {etsy20SortByParams} params - The parameters for this event
 * @property {GUID} instance_id - comp id
 * @property {GUID} app_site_id - instance id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} sort_by - Most Recent / Relevance / Highest Price / Loweat Price
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<etsy20SortByParams>} LogObject<etsy20SortByParams>
 */
export function etsy20SortBy(params) {
    return { evid: 350, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'resultsViewSrc63Evid4' event (evid: 4)
 *
 * Event description: View of the generated result
 *
 * @param {resultsViewSrc63Evid4Params} params - The parameters for this event
 * @property {string} option - Text result: 1, 2, 3
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @return {LogObject<resultsViewSrc63Evid4Params>} LogObject<resultsViewSrc63Evid4Params>
 */
export function resultsViewSrc63Evid4(params) {
    return { evid: 4, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsensePageOpen' event (evid: 400)
 *
 * Event description: a generic event sent when the Setting Panel is opened
 *
 * @param {googleAdsensePageOpenParams} params - The parameters for this event
 * @property {GUID} app_site_id - = app instance id
 * @property {string} state - ----- DEPRECATED -----
 * @property {GUID} biToken - msid
 * @property {string} page_name - page name
 * @property {string} origin - ----- DEPRECATED -----
 * @property {GUID} comp_id - ----- DEPRECATED -----
 * @property {string} instance_id - = app comp id
 * @return {LogObject<googleAdsensePageOpenParams>} LogObject<googleAdsensePageOpenParams>
 */
export function googleAdsensePageOpen(params) {
    return { evid: 400, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adsClickOnLink' event (evid: 401)
 *
 * Event description: user clicks on link in the setting panel
 *
 * @param {adsClickOnLinkParams} params - The parameters for this event
 * @property {GUID} app_site_id - = app instance id
 * @property {GUID} biToken - msid
 * @property {string} description - link description {connect domain, instructions}
 * @property {string} origin - where was the link clicked from {setup_welcome,active_ad_code}
 * @property {GUID} comp_id - ----- DEPRECATED -----
 * @property {string} instance_id - = app comp id
 * @return {LogObject<adsClickOnLinkParams>} LogObject<adsClickOnLinkParams>
 */
export function adsClickOnLink(params) {
    return { evid: 401, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseConnectedMyDomainFill' event (evid: 402)
 *
 * Event description: connected_my_domain_Fill
 *
 * @param {googleAdsenseConnectedMyDomainFillParams} params - The parameters for this event
 * @property {GUID} app_site_id - = app instance id
 * @property {GUID} biToken - msid
 * @property {boolean} is_first - true/false , (is it the first time the user fill this?)
 * @property {boolean} is_success - true/false , (is the site have connected domain?)
 * @property {GUID} comp_id - ----- DEPRECATED -----
 * @property {string} instance_id - = app comp id
 * @return {LogObject<googleAdsenseConnectedMyDomainFillParams>} LogObject<googleAdsenseConnectedMyDomainFillParams>
 */
export function googleAdsenseConnectedMyDomainFill(params) {
    return { evid: 402, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adsClickOnButton' event (evid: 403)
 *
 * Event description: user clicks on a button in the setting panel
 *
 * @param {adsClickOnButtonParams} params - The parameters for this event
 * @property {GUID} app_site_id - = app instance id
 * @property {GUID} biToken - msid
 * @property {string} description - button name - {get_started,activate,replace, go_to_add_sense}
 * @property {boolean} is_active_account - ----- DEPRECATED -----
 * @property {string} origin - the page in which the button is clicked
 * @property {GUID} comp_id - ----- DEPRECATED -----
 * @property {string} instance_id - = app comp id
 * @return {LogObject<adsClickOnButtonParams>} LogObject<adsClickOnButtonParams>
 */
export function adsClickOnButton(params) {
    return { evid: 403, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseSignUpPastedCodeFill' event (evid: 405)
 *
 * Event description: sent when there is an error with an ad
 *
 * @param {googleAdsenseSignUpPastedCodeFillParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} description - TBD
 * @property {GUID} comp_id - --deprectaed
 * @property {string} type - error type {ads, domain}
 * @property {string} instance_id - instance_id (COMP_ID)
 * @property {boolean} is_error - --deprecated
 * @return {LogObject<googleAdsenseSignUpPastedCodeFillParams>} LogObject<googleAdsenseSignUpPastedCodeFillParams>
 */
export function googleAdsenseSignUpPastedCodeFill(params) {
    return { evid: 405, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsensePasteAdCode' event (evid: 406)
 *
 * Event description: when the user pastes adsense ad unit code.
 *
 * @param {googleAdsensePasteAdCodeParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} description - type not supported, already showing this Ad, wrong code, successfully added
 * @property {string} origin - Ad codes, set up Ad, create Ad
 * @property {GUID} comp_id - ---deprecated
 * @property {string} instance_id - instance_id
 * @return {LogObject<googleAdsensePasteAdCodeParams>} LogObject<googleAdsensePasteAdCodeParams>
 */
export function googleAdsensePasteAdCode(params) {
    return { evid: 406, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseSignInClick' event (evid: 407)
 *
 * Event description: the user clicks 'sign in'
 *
 * @param {googleAdsenseSignInClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} comp_id - comp_id
 * @property {string} instance_id - instance_id
 * @return {LogObject<googleAdsenseSignInClickParams>} LogObject<googleAdsenseSignInClickParams>
 */
export function googleAdsenseSignInClick(params) {
    return { evid: 407, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseAddedToAdsTxt' event (evid: 410)
 *
 * Event description: User cicks 'next' and after we verify the code exist we send the pub_id to promote API
 *
 * @param {googleAdsenseAddedToAdsTxtParams} params - The parameters for this event
 * @property {GUID} app_site_id - = app instance id
 * @property {GUID} biToken - msid
 * @property {number} pub_id - pub_id
 * @property {GUID} comp_id - ----- DEPRECATED -----
 * @property {string} instance_id - = app comp id
 * @return {LogObject<googleAdsenseAddedToAdsTxtParams>} LogObject<googleAdsenseAddedToAdsTxtParams>
 */
export function googleAdsenseAddedToAdsTxt(params) {
    return { evid: 410, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareWidgetDetails' event (evid: 418)
 *
 * Event description: when the user publishes the site
 *
 * @param {fileShareWidgetDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {GUID} biToken - msid
 * @property {boolean} display_favorites - [Display tab] display favorite counter: true/false
 * @property {string} icon - [Display tab] icon style: extension/ classic/ line
 * @property {boolean} display_search_bar - [Display tab] display search bar
 * @property {number} folder_id - ***deprecated*** wrong data type
 * @property {boolean} display_views - [Display tab] display views: true/false
 * @property {boolean} layout_alignment - [Display tab] Layout alignment: True - left / False - right
 * @property {boolean} display_size - [Display tab] display size: true/false
 * @property {boolean} display_favorites_counter - true/false
 * @property {boolean} display_owner - [Display tab] display owner: true/false
 * @property {string} sort_by - last updated A-Z Z-A most viewed most favorites item type item size
 * @property {boolean} display_date - [Display tab] display owner: true/false
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp id
 * @property {string} folder_name - folder name of the folder that was chosen
 * @property {GUID} parent_folder_id - folder_id of the folder that was chosen
 * @return {LogObject<fileShareWidgetDetailsParams>} LogObject<fileShareWidgetDetailsParams>
 */
export function fileShareWidgetDetails(params) {
    return { evid: 418, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareDetails' event (evid: 420)
 *
 * Event description: when the user publishes the site
 *
 * @param {fileShareDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {boolean} is_favorite_allowed - [Settings tab] let members favorite files: true/false
 * @property {number} max_upload_size - -----        DEPRECATED         ------  send empty
 * @property {string} view_and_download - [Settings tab] who can view and download files: members_only / anyone
 * @property {GUID} biToken - msid
 * @property {string} upload_files - [Settings tab] who can upload files: admins / all members / <custom_string>
 * @property {boolean} display_favorites - [Display tab] display favorite counter: true/false
 * @property {string} icon - [Display tab] icon style: extension/ classic/ line
 * @property {boolean} display_views - [Display tab] display views: true/false
 * @property {boolean} layout_alignment - [Display tab] Layout alignment: True - left / False - right
 * @property {boolean} display_size - [Display tab] display size: true/false
 * @property {boolean} display_favorites_counter - true/false
 * @property {string} create_folders - [Settings tab] who can create folders:   admins / all members / <custom_string>
 * @property {boolean} display_owner - [Display tab] display owner: true/false
 * @property {boolean} display_date - [Display tab] display owner: true/false
 * @property {string} manage_library - admins, all members, <custom_string>
 * @property {boolean} is_video_allowed - true/false
 * @property {string} app_id - app_id
 * @property {boolean} is_premium - true/false - is the site premium
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareDetailsParams>} LogObject<fileShareDetailsParams>
 */
export function fileShareDetails(params) {
    return { evid: 420, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareNewFileClick' event (evid: 421)
 *
 * Event description: when the user clicks on 'new file' button
 *
 * @param {fileShareNewFileClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_first - true/false - is this the first click
 * @property {string} origin - null or upload_button
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @return {LogObject<fileShareNewFileClickParams>} LogObject<fileShareNewFileClickParams>
 */
export function fileShareNewFileClick(params) {
    return { evid: 421, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareNewFolderClick' event (evid: 422)
 *
 * Event description: when the user clicks on 'new folder' button
 *
 * @param {fileShareNewFolderClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_first - true/false - is this the first click
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @return {LogObject<fileShareNewFolderClickParams>} LogObject<fileShareNewFolderClickParams>
 */
export function fileShareNewFolderClick(params) {
    return { evid: 422, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareCameraClick' event (evid: 423)
 *
 * Event description: when the user clicks on 'camera' button
 *
 * @param {fileShareCameraClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_first - true/false - is this the first click
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @return {LogObject<fileShareCameraClickParams>} LogObject<fileShareCameraClickParams>
 */
export function fileShareCameraClick(params) {
    return { evid: 423, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareNewFileCreated' event (evid: 424)
 *
 * Event description: when a new file created
 *
 * @param {fileShareNewFileCreatedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} action_id - action_id of the request. to join try and success events
 * @property {GUID} file_id - unique id for each file
 * @property {boolean} is_camera - true/false - is the file uploaded via camera
 * @property {string} file_name - file_name
 * @property {GUID} biToken - msid
 * @property {string} description - load, create
 * @property {number} file_size - file_size
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_first - true/false - is this the first click
 * @property {string} origin - origin
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {GUID} parent_folder_id - parent_folder_id
 * @property {string} level - level
 * @return {LogObject<fileShareNewFileCreatedParams>} LogObject<fileShareNewFileCreatedParams>
 */
export function fileShareNewFileCreated(params) {
    return { evid: 424, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareNewFolderCreated' event (evid: 425)
 *
 * Event description: when a new folder created
 *
 * @param {fileShareNewFolderCreatedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} action_id - action_id of the request. to join try and success events
 * @property {boolean} is_camera - true/false - is the file uploaded via camera
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_first - true/false - is this the first click
 * @property {string} origin - from where the folder creates: 'home' if opened from main window / 'move' if opened from the move dialog
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} folder_name - folder_name
 * @property {GUID} parent_folder_id - parent_folder_id
 * @property {string} level - level
 * @return {LogObject<fileShareNewFolderCreatedParams>} LogObject<fileShareNewFolderCreatedParams>
 */
export function fileShareNewFolderCreated(params) {
    return { evid: 425, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFileMenuClick' event (evid: 426)
 *
 * Event description: click on file menu
 *
 * @param {fileShareFileMenuClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {string} button_description - download, share, rename, move, delete, permissions
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {number} num_of_files_selected - the number of files selected
 * @property {boolean} is_file_owner - True/False
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} origin - multi selection / single item
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file = visitor id = aid
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileShareFileMenuClickParams>} LogObject<fileShareFileMenuClickParams>
 */
export function fileShareFileMenuClick(params) {
    return { evid: 426, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareDeleteFile' event (evid: 427)
 *
 * Event description: click on file menu
 *
 * @param {fileShareDeleteFileParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} action_id - action_id of the request. to join try and success events
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {string} description - click, deleted
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {number} num_of_files_selected - the number of files selected
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} origin - multi selection / single item
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileShareDeleteFileParams>} LogObject<fileShareDeleteFileParams>
 */
export function fileShareDeleteFile(params) {
    return { evid: 427, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareMoveFileClick' event (evid: 428)
 *
 * Event description: click on file menu
 *
 * @param {fileShareMoveFileClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} action_id - action_id of the request. to join try and success events
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {string} description - click, moved
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {number} num_of_files_selected - the number of files selected
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} origin - multi selection / single item
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileShareMoveFileClickParams>} LogObject<fileShareMoveFileClickParams>
 */
export function fileShareMoveFileClick(params) {
    return { evid: 428, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareRenameFile' event (evid: 429)
 *
 * Event description: view file
 *
 * @param {fileShareRenameFileParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} action_id - action_id of the request. to join try and success events
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileShareRenameFileParams>} LogObject<fileShareRenameFileParams>
 */
export function fileShareRenameFile(params) {
    return { evid: 429, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareSortBy' event (evid: 430)
 *
 * Event description: sort by :
 * date, name, type, owner, stars, views
 *
 * @param {fileShareSortByParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {string} button_description - date, name, type, owner, stars, views
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_first - true/false
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<fileShareSortByParams>} LogObject<fileShareSortByParams>
 */
export function fileShareSortBy(params) {
    return { evid: 430, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareSearch' event (evid: 431)
 *
 * Event description: search
 *
 * @param {fileShareSearchParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {string} search_text - search_text
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} results_count - number of results
 * @property {string} origin - home, folder
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} folder_name - folder_name
 * @return {LogObject<fileShareSearchParams>} LogObject<fileShareSearchParams>
 */
export function fileShareSearch(params) {
    return { evid: 431, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareViewFile' event (evid: 432)
 *
 * Event description: view file / open folder
 *
 * @param {fileShareViewFileParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_restricted - is_restricted
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileShareViewFileParams>} LogObject<fileShareViewFileParams>
 */
export function fileShareViewFile(params) {
    return { evid: 432, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFavoriteClickSrc63Evid433' event (evid: 433)
 *
 * Event description: Favorite click
 *
 * @param {fileShareFavoriteClickSrc63Evid433Params} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileShareFavoriteClickSrc63Evid433Params>} LogObject<fileShareFavoriteClickSrc63Evid433Params>
 */
export function fileShareFavoriteClickSrc63Evid433(params) {
    return { evid: 433, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareViewAppPage' event (evid: 435)
 *
 * Event description: event triggered when the app is viewed in the live site
 *
 * @param {fileShareViewAppPageParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} instance_id - comp_id
 * @return {LogObject<fileShareViewAppPageParams>} LogObject<fileShareViewAppPageParams>
 */
export function fileShareViewAppPage(params) {
    return { evid: 435, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareViewAppPageSrc63Evid436' event (evid: 436)
 *
 * Event description: event triggered when the app is viewed in the live site
 *
 * @param {fileShareViewAppPageSrc63Evid436Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} view_type - widget / page app
 * @property {number} folder_id - only for widget = the id of the folder that the user chose to show
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {GUID} widget_folder_id - only for widget = the id of the folder that the user chose to show
 * @property {string} folder_name - only for widget = the name of the folder that the user chose to show
 * @return {LogObject<fileShareViewAppPageSrc63Evid436Params>} LogObject<fileShareViewAppPageSrc63Evid436Params>
 */
export function fileShareViewAppPageSrc63Evid436(params) {
    return { evid: 436, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareDownloadFile' event (evid: 437)
 *
 * Event description: the event is triggered when clicking download
 *
 * @param {fileShareDownloadFileParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} instance_id - comp_id
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileShareDownloadFileParams>} LogObject<fileShareDownloadFileParams>
 */
export function fileShareDownloadFile(params) {
    return { evid: 437, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareReportSrc63Evid438' event (evid: 438)
 *
 * Event description: User or UoU report on a file / folder
 *
 * @param {fileShareReportSrc63Evid438Params} params - The parameters for this event
 * @property {GUID} instance_id - comp_id
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {GUID} biToken - msid
 * @property {number} file_size - size of the file
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - instance_id
 * @property {GUID} app_id - app_id
 * @property {string} file_type - type of the file
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @property {string} report_reason - one of the four reasons of report
 * @return {LogObject<fileShareReportSrc63Evid438Params>} LogObject<fileShareReportSrc63Evid438Params>
 */
export function fileShareReportSrc63Evid438(params) {
    return { evid: 438, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareOpenInLibraryClick' event (evid: 439)
 *
 * Event description: open in library click in members area
 *
 * @param {fileShareOpenInLibraryClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} file_id - file_id
 * @property {string} file_name - file_name
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {number} file_size - file_size
 * @property {number} favorites_count - number of favorites
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} file_owner_id - visitor id of the file owner
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} file_owner - Site Member who upload the file
 * @property {string} file_type - file_type
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @return {LogObject<fileShareOpenInLibraryClickParams>} LogObject<fileShareOpenInLibraryClickParams>
 */
export function fileShareOpenInLibraryClick(params) {
    return { evid: 439, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareUploadsTabClick' event (evid: 440)
 *
 * Event description: uploads tab click in members area
 *
 * @param {fileShareUploadsTabClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @return {LogObject<fileShareUploadsTabClickParams>} LogObject<fileShareUploadsTabClickParams>
 */
export function fileShareUploadsTabClick(params) {
    return { evid: 440, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareUpgradeClickButton' event (evid: 441)
 *
 * Event description: when the user click on upgrade inside the app settings
 *
 * @param {fileShareUpgradeClickButtonParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareUpgradeClickButtonParams>} LogObject<fileShareUpgradeClickButtonParams>
 */
export function fileShareUpgradeClickButton(params) {
    return { evid: 441, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsOpen' event (evid: 442)
 *
 * Event description: when the user click permissions inside the app settings
 *
 * @param {fileSharePermissionsOpenParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} instance_id - comp id
 * @return {LogObject<fileSharePermissionsOpenParams>} LogObject<fileSharePermissionsOpenParams>
 */
export function fileSharePermissionsOpen(params) {
    return { evid: 442, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsClose' event (evid: 443)
 *
 * Event description: when the user closes permissions inside the app settings
 *
 * @param {fileSharePermissionsCloseParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} instance_id - comp id
 * @return {LogObject<fileSharePermissionsCloseParams>} LogObject<fileSharePermissionsCloseParams>
 */
export function fileSharePermissionsClose(params) {
    return { evid: 443, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsClickBmRolesLink' event (evid: 444)
 *
 * Event description: when the user clicks on roles link in the app settings
 *
 * @param {fileSharePermissionsClickBmRolesLinkParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} instance_id - comp id
 * @return {LogObject<fileSharePermissionsClickBmRolesLinkParams>} LogObject<fileSharePermissionsClickBmRolesLinkParams>
 */
export function fileSharePermissionsClickBmRolesLink(params) {
    return { evid: 444, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareMembersSignupSettingsClickLink' event (evid: 445)
 *
 * Event description: when the user clicks on members signup settings in the app settings
 *
 * @param {fileShareMembersSignupSettingsClickLinkParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareMembersSignupSettingsClickLinkParams>} LogObject<fileShareMembersSignupSettingsClickLinkParams>
 */
export function fileShareMembersSignupSettingsClickLink(params) {
    return { evid: 445, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFavoritesTabClick' event (evid: 446)
 *
 * Event description: My Favorites tab click in members area
 *
 * @param {fileShareFavoritesTabClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @return {LogObject<fileShareFavoritesTabClickParams>} LogObject<fileShareFavoritesTabClickParams>
 */
export function fileShareFavoritesTabClick(params) {
    return { evid: 446, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareManageFilesClick' event (evid: 447)
 *
 * Event description: when a user clicks on manage Files in the editor settings
 *
 * @param {fileShareManageFilesClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<fileShareManageFilesClickParams>} LogObject<fileShareManageFilesClickParams>
 */
export function fileShareManageFilesClick(params) {
    return { evid: 447, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsSavedStep1' event (evid: 450)
 *
 * Event description: when permissions saved in step 1 (first window)
 *
 * @param {fileSharePermissionsSavedStep1Params} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {boolean} alert_notification - if saved and the alert of conflicting permissions is still still shown
 * @property {number} specific_members_count - specific_members_count
 * @property {number} roles_count - roles_count
 * @property {number} plans_count - plans_count
 * @property {GUID} file_id - file_id / folder_id
 * @property {number} view_count - view_count
 * @property {GUID} biToken - msid
 * @property {number} badges_count - badges_count
 * @property {number} manage_count - manage_count
 * @property {string} isHidden - true / false
 * @property {GUID} visitor_id - visitor_id
 * @property {number} all_members - 0/1
 * @property {number} upload_count - upload_count
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {number} total_permissions_count - total_permissions_count
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @property {number} site_visitors - 0/1
 * @property {boolean} isFromAiAssistant - if it was triggered by AI
 * @return {LogObject<fileSharePermissionsSavedStep1Params>} LogObject<fileSharePermissionsSavedStep1Params>
 */
export function fileSharePermissionsSavedStep1(params) {
    return { evid: 450, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsSavedStep2' event (evid: 451)
 *
 * Event description: when permissions saved in step 2 (second window when then the members can be notified)
 *
 * @param {fileSharePermissionsSavedStep2Params} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} file_id - file_id / folder_id
 * @property {GUID} biToken - msid
 * @property {string} notification - 3 options: didnt_notify, notify_with_massage, notify_without_massage (empty text box)
 * @property {GUID} visitor_id - visitor_id
 * @property {number} tags_count - (how many permissions groups)
 * @property {string} permission_type - view / upload / manage
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileSharePermissionsSavedStep2Params>} LogObject<fileSharePermissionsSavedStep2Params>
 */
export function fileSharePermissionsSavedStep2(params) {
    return { evid: 451, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsSignAdded' event (evid: 452)
 *
 * Event description: when the lock or dollar sign is added to the restricted folder
 *
 * @param {fileSharePermissionsSignAddedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} file_id - file_id / folder_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} type - lock / dollar
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileSharePermissionsSignAddedParams>} LogObject<fileSharePermissionsSignAddedParams>
 */
export function fileSharePermissionsSignAdded(params) {
    return { evid: 452, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsSignRemoved' event (evid: 454)
 *
 * Event description: when the lock or dollar sign is added to the restricted folder
 *
 * @param {fileSharePermissionsSignRemovedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} file_id - file_id / folder_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} type - lock / dollar
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileSharePermissionsSignRemovedParams>} LogObject<fileSharePermissionsSignRemovedParams>
 */
export function fileSharePermissionsSignRemoved(params) {
    return { evid: 454, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsAccessWindowOpened' event (evid: 455)
 *
 * Event description: when clicking on the restricted folder and the get access window opens
 *
 * @param {fileSharePermissionsAccessWindowOpenedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} file_id - file_id / folder_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} type - lock / dollar
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileSharePermissionsAccessWindowOpenedParams>} LogObject<fileSharePermissionsAccessWindowOpenedParams>
 */
export function fileSharePermissionsAccessWindowOpened(params) {
    return { evid: 455, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileSharePermissionsGetAccessClick' event (evid: 456)
 *
 * Event description: when clicking on the button in the get access window when the visitor don't have permissions to the folder
 *
 * @param {fileSharePermissionsGetAccessClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} button_description - send_request /switch_account / see_plans / login
 * @property {GUID} file_id - file_id / folder_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} type - lock / dollar
 * @property {boolean} is_folder - is_folder
 * @return {LogObject<fileSharePermissionsGetAccessClickParams>} LogObject<fileSharePermissionsGetAccessClickParams>
 */
export function fileSharePermissionsGetAccessClick(params) {
    return { evid: 456, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBackOfficeLoaded' event (evid: 460)
 *
 * Event description: when the user opens the back office  start loading
 *
 * @param {fileShareBackOfficeLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareBackOfficeLoadedParams>} LogObject<fileShareBackOfficeLoadedParams>
 */
export function fileShareBackOfficeLoaded(params) {
    return { evid: 460, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBackOfficeFinishedLoading' event (evid: 461)
 *
 * Event description: when the user opens the back office and it loaded successfully
 *
 * @param {fileShareBackOfficeFinishedLoadingParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareBackOfficeFinishedLoadingParams>} LogObject<fileShareBackOfficeFinishedLoadingParams>
 */
export function fileShareBackOfficeFinishedLoading(params) {
    return { evid: 461, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoPricingPlanBannerClick' event (evid: 462)
 *
 * Event description: BO pricing plan banner click
 *
 * @param {fileShareBoPricingPlanBannerClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} type - pricing plan Installed / pricing plan not installed
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareBoPricingPlanBannerClickParams>} LogObject<fileShareBoPricingPlanBannerClickParams>
 */
export function fileShareBoPricingPlanBannerClick(params) {
    return { evid: 462, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoSettingsClick' event (evid: 463)
 *
 * Event description: when clicking on the settings in the BO
 *
 * @param {fileShareBoSettingsClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareBoSettingsClickParams>} LogObject<fileShareBoSettingsClickParams>
 */
export function fileShareBoSettingsClick(params) {
    return { evid: 463, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoSettingsLoaded' event (evid: 464)
 *
 * Event description: BO settings loaded
 *
 * @param {fileShareBoSettingsLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {number} specific_members_count - specific_members_count
 * @property {number} roles_count - roles_count
 * @property {number} plans_count - plans_count
 * @property {GUID} biToken - msid
 * @property {number} badges_count - badges_count
 * @property {number} manage_count - manage_count
 * @property {number} admins - always 1
 * @property {number} all_members - 0/1
 * @property {number} upload_count - upload_count
 * @property {string} view_permissions - all members / site visitors
 * @property {number} total_permissions_count - total_permissions_count
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} instance_id - instance_id
 * @return {LogObject<fileShareBoSettingsLoadedParams>} LogObject<fileShareBoSettingsLoadedParams>
 */
export function fileShareBoSettingsLoaded(params) {
    return { evid: 464, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoSettingsSaveClick' event (evid: 465)
 *
 * Event description: when BO settings save click
 *
 * @param {fileShareBoSettingsSaveClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {number} specific_members_count - specific_members_count
 * @property {number} roles_count - roles_count
 * @property {number} plans_count - plans_count
 * @property {GUID} biToken - msid
 * @property {number} badges_count - badges_count
 * @property {number} manage_count - manage_count
 * @property {number} admins - always 1
 * @property {number} all_members - 0/1
 * @property {number} upload_count - upload_count
 * @property {string} view_permissions - all members / site visitors
 * @property {number} total_permissions_count - total_permissions_count
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} instance_id - instance_id
 * @return {LogObject<fileShareBoSettingsSaveClickParams>} LogObject<fileShareBoSettingsSaveClickParams>
 */
export function fileShareBoSettingsSaveClick(params) {
    return { evid: 465, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoSettingsSaved' event (evid: 466)
 *
 * Event description: BO settings saved
 *
 * @param {fileShareBoSettingsSavedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {number} specific_members_count - specific_members_count
 * @property {number} roles_count - roles_count
 * @property {number} plans_count - plans_count
 * @property {GUID} biToken - msid
 * @property {number} badges_count - badges_count
 * @property {number} manage_count - manage_count
 * @property {number} admins - always 1
 * @property {number} all_members - 0/1
 * @property {number} upload_count - upload_count
 * @property {string} view_permissions - all members / site visitors
 * @property {number} total_permissions_count - total_permissions_count
 * @property {string} owner - Owner (who does the ‘action’) = Role = member/admin/moderator/<custom_string>
 * @property {string} instance_id - instance_id
 * @return {LogObject<fileShareBoSettingsSavedParams>} LogObject<fileShareBoSettingsSavedParams>
 */
export function fileShareBoSettingsSaved(params) {
    return { evid: 466, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoSettingsPricingPlansMemberRolesClick' event (evid: 467)
 *
 * Event description: pricing plans / member roles click in the settings
 *
 * @param {fileShareBoSettingsPricingPlansMemberRolesClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} type - pricing plan installed /  pricing plan not installed  / member roles
 * @property {string} instance_id - instance_id
 * @return {LogObject<fileShareBoSettingsPricingPlansMemberRolesClickParams>} LogObject<fileShareBoSettingsPricingPlansMemberRolesClickParams>
 */
export function fileShareBoSettingsPricingPlansMemberRolesClick(params) {
    return { evid: 467, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoSettingsLearnMoreClick' event (evid: 468)
 *
 * Event description: learn more click in the settings
 *
 * @param {fileShareBoSettingsLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - Instance id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} type - settings view / save settings modal
 * @property {string} instance_id - comp id
 * @return {LogObject<fileShareBoSettingsLearnMoreClickParams>} LogObject<fileShareBoSettingsLearnMoreClickParams>
 */
export function fileShareBoSettingsLearnMoreClick(params) {
    return { evid: 468, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refineClickSrc63Evid5' event (evid: 5)
 *
 * Event description: Click on refine button
 *
 * @param {refineClickSrc63Evid5Params} params - The parameters for this event
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @return {LogObject<refineClickSrc63Evid5Params>} LogObject<refineClickSrc63Evid5Params>
 */
export function refineClickSrc63Evid5(params) {
    return { evid: 5, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFileOrFolderCreated' event (evid: 504)
 *
 * Event description: User or UoU upload file or create folder
 *
 * @param {fileShareFileOrFolderCreatedParams} params - The parameters for this event
 * @property {boolean} success - Ture - when action is finished. False - when started (try)
 * @property {GUID} action_id - action_id to join both try and success
 * @property {GUID} file_id - unique id for a file
 * @property {string} file_name - name of file or folder
 * @property {GUID} biToken - msid
 * @property {number} file_size - file size
 * @property {string} file_type - based on the name of the file
 * @property {GUID} site_member_id - when a visitor is signed in to the live site (UID)
 * @property {GUID} msid - msid
 * @property {boolean} is_folder - True/False if folder or file
 * @property {string} instance_id - instance id
 * @property {string} parent_folder - the folder that the file was created in. if this is a new folder (not a new file) than null.
 * @return {LogObject<fileShareFileOrFolderCreatedParams>} LogObject<fileShareFileOrFolderCreatedParams>
 */
export function fileShareFileOrFolderCreated(params) {
    return { evid: 504, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFileOrFolderDeleted' event (evid: 505)
 *
 * Event description: User or UoU delete file or folder
 *
 * @param {fileShareFileOrFolderDeletedParams} params - The parameters for this event
 * @property {GUID} action_id - action_id to join both try and success
 * @property {GUID} file_id - unique id for a file
 * @property {string} file_name - name of file or folder
 * @property {GUID} biToken - msid
 * @property {GUID} site_member_id - when a visitor is signed in to the live site (UID)
 * @property {GUID} msid - msid
 * @property {boolean} is_folder - True/False if folder or file
 * @property {string} instance_id - instance id
 * @return {LogObject<fileShareFileOrFolderDeletedParams>} LogObject<fileShareFileOrFolderDeletedParams>
 */
export function fileShareFileOrFolderDeleted(params) {
    return { evid: 505, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFileOrFolderRenamed' event (evid: 506)
 *
 * Event description: User or UoU rename file or folder
 *
 * @param {fileShareFileOrFolderRenamedParams} params - The parameters for this event
 * @property {GUID} action_id - action_id to join both try and success
 * @property {GUID} file_id - unique id for a file
 * @property {string} file_name - name of file or folder
 * @property {GUID} biToken - msid
 * @property {GUID} site_member_id - when a visitor is signed in to the live site (UID)
 * @property {GUID} msid - msid
 * @property {boolean} is_folder - True/False if folder or file
 * @property {string} instance_id - instance id
 * @return {LogObject<fileShareFileOrFolderRenamedParams>} LogObject<fileShareFileOrFolderRenamedParams>
 */
export function fileShareFileOrFolderRenamed(params) {
    return { evid: 506, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFileOrFolderMoved' event (evid: 507)
 *
 * Event description: User or UoU rename file or folder
 *
 * @param {fileShareFileOrFolderMovedParams} params - The parameters for this event
 * @property {GUID} action_id - action_id to join both try and success
 * @property {GUID} file_id - unique id for a file
 * @property {string} file_name - name of file or folder
 * @property {GUID} biToken - msid
 * @property {GUID} site_member_id - when a visitor is signed in to the live site (UID)
 * @property {GUID} msid - msid
 * @property {boolean} is_folder - True/False if folder or file
 * @property {string} instance_id - instance id
 * @return {LogObject<fileShareFileOrFolderMovedParams>} LogObject<fileShareFileOrFolderMovedParams>
 */
export function fileShareFileOrFolderMoved(params) {
    return { evid: 507, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareFavoriteClick' event (evid: 509)
 *
 * Event description: User or UoU mark file or folder as a favorite
 *
 * @param {fileShareFavoriteClickParams} params - The parameters for this event
 * @property {GUID} action_id - action_id to join both try and success
 * @property {GUID} file_id - unique id for a file
 * @property {string} file_name - name of file or folder
 * @property {GUID} biToken - msid
 * @property {GUID} site_member_id - when a visitor is signed in to the live site (UID)
 * @property {GUID} msid - msid
 * @property {boolean} is_folder - True/False if folder or file
 * @property {string} instance_id - instance id
 * @return {LogObject<fileShareFavoriteClickParams>} LogObject<fileShareFavoriteClickParams>
 */
export function fileShareFavoriteClick(params) {
    return { evid: 509, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareReport' event (evid: 510)
 *
 * Event description: User or UoU report on file / folder
 *
 * @param {fileShareReportParams} params - The parameters for this event
 * @property {GUID} action_id - action_id to join both try and success
 * @property {GUID} file_id - unique id for a file
 * @property {string} file_name - name of file or folder
 * @property {GUID} biToken - msid
 * @property {GUID} site_member_id - when a visitor is signed in to the live site (UID)
 * @property {GUID} msid - msid
 * @property {boolean} is_folder - True/False if folder or file
 * @property {string} instance_id - instance id
 * @property {string} report_reason - one of the four reasons of the report
 * @return {LogObject<fileShareReportParams>} LogObject<fileShareReportParams>
 */
export function fileShareReport(params) {
    return { evid: 510, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDetails' event (evid: 520)
 *
 * Event description: The user publish the site with shared gallery.
 *
 * @param {sharedGalleryDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {boolean} display_album_num_of_items - true / false
 * @property {string} gallery_title - the title of the gallery
 * @property {GUID} biToken - msid
 * @property {string} albums_hover - no effect / zoom in / shrink / blur
 * @property {boolean} display_description - true / false
 * @property {string} manage_gallery - admins, all members, <custom_string>
 * @property {boolean} display_likes - true / false
 * @property {boolean} display_album_date_created - true / false
 * @property {boolean} enable_video - True / False
 * @property {boolean} display_views - True / False
 * @property {boolean} layout_alignment - True (left) / False (right)
 * @property {string} layout_chosen - Masonry / Grid / Feed in web
 * @property {string} uploads_photo - -- Deprecated
 * @property {string} layout_chosen_oneapp - Feed / Masonry in one app
 * @property {string} default_sort_album - album default sort - Recent Activity / Album Name (A-Z) / Most tagged members / Most Comments
 * @property {string} item_style - minimal / profile / detailed
 * @property {boolean} enable_comments - True / False
 * @property {string} manage_album - admins, all members, <custom_string>
 * @property {string} layout_albums - classic / overlay / side by side
 * @property {boolean} enable_tagging - True / False
 * @property {string} instance_id - instance_id
 * @property {string} create_album - admins, all members, <custom_string>
 * @property {string} download_photos - no one / everyone / members only
 * @property {boolean} display_avatar - true / false
 * @property {string} default_sort - the galery default sort
 * @property {string} upload_photos - who can upload media: admins / all members / <custom_string>
 * @return {LogObject<sharedGalleryDetailsParams>} LogObject<sharedGalleryDetailsParams>
 */
export function sharedGalleryDetails(params) {
    return { evid: 520, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryAddPhotoClick' event (evid: 521)
 *
 * Event description: User or UoU add a photo.
 *
 * @param {sharedGalleryAddPhotoClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {string} button_description - take a photo / choose from device
 * @property {string} button_type - top page button  / empty state inside gallery button
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - album_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - image / video
 * @return {LogObject<sharedGalleryAddPhotoClickParams>} LogObject<sharedGalleryAddPhotoClickParams>
 */
export function sharedGalleryAddPhotoClick(params) {
    return { evid: 521, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryNewPhotoAdded' event (evid: 522)
 *
 * Event description: New photo added to the app.
 *
 * @param {sharedGalleryNewPhotoAddedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {string} photo_type - the type of the photo (by the end of the photo name)
 * @property {GUID} action_id - unique id for action to join the actions on the client and the server
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {number} photo_size - the size of the photo
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @return {LogObject<sharedGalleryNewPhotoAddedParams>} LogObject<sharedGalleryNewPhotoAddedParams>
 */
export function sharedGalleryNewPhotoAdded(params) {
    return { evid: 522, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGallerySortBy' event (evid: 523)
 *
 * Event description: User or UoU sort by.
 *
 * @param {sharedGallerySortByParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - album_id
 * @property {string} sort_by - Most Recent / Most tagged members / Most Liked / Most Comments
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<sharedGallerySortByParams>} LogObject<sharedGallerySortByParams>
 */
export function sharedGallerySortBy(params) {
    return { evid: 523, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryExpandPhoto' event (evid: 524)
 *
 * Event description: User or UoU click on a photo.
 *
 * @param {sharedGalleryExpandPhotoParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {string} photo_type - the type of the photo (by the end of the photo name)
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {number} views_count - number of views
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {number} photo_size - the size of the photo
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @return {LogObject<sharedGalleryExpandPhotoParams>} LogObject<sharedGalleryExpandPhotoParams>
 */
export function sharedGalleryExpandPhoto(params) {
    return { evid: 524, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryTagMembers' event (evid: 525)
 *
 * Event description: User or UoU tag members on a photo
 *
 * @param {sharedGalleryTagMembersParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {number} number_of_tags - number of members that tagged in the photo
 * @property {string} photo_name - The name of the file
 * @return {LogObject<sharedGalleryTagMembersParams>} LogObject<sharedGalleryTagMembersParams>
 */
export function sharedGalleryTagMembers(params) {
    return { evid: 525, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDescribePhotoSrc63Evid526' event (evid: 526)
 *
 * Event description: User or UoU add a description to the photo.
 *
 * @param {sharedGalleryDescribePhotoSrc63Evid526Params} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} hashtag_count - hashtag
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {number} mention_count - mention
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {number} link_count - links
 * @property {string} photo_name - The name of the file
 * @property {number} emoji_count - emoji
 * @return {LogObject<sharedGalleryDescribePhotoSrc63Evid526Params>} LogObject<sharedGalleryDescribePhotoSrc63Evid526Params>
 */
export function sharedGalleryDescribePhotoSrc63Evid526(params) {
    return { evid: 526, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryLike' event (evid: 527)
 *
 * Event description: User or UoU click on love a photo
 *
 * @param {sharedGalleryLikeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {boolean} is_new_like - True if it's a like and False if the click delete the like.
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {number} likes_count - number of likes
 * @property {string} photo_name - The name of the file
 * @return {LogObject<sharedGalleryLikeParams>} LogObject<sharedGalleryLikeParams>
 */
export function sharedGalleryLike(params) {
    return { evid: 527, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryShare' event (evid: 528)
 *
 * Event description: User or UoU share a photo.
 *
 * @param {sharedGalleryShareParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @return {LogObject<sharedGalleryShareParams>} LogObject<sharedGalleryShareParams>
 */
export function sharedGalleryShare(params) {
    return { evid: 528, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryReport' event (evid: 529)
 *
 * Event description: User or UoU report on a photo.
 *
 * @param {sharedGalleryReportParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {string} mode - expand / gallery (from which mode the photo was reported)
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @property {string} report_reason - the reason of the report
 * @return {LogObject<sharedGalleryReportParams>} LogObject<sharedGalleryReportParams>
 */
export function sharedGalleryReport(params) {
    return { evid: 529, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDelete' event (evid: 530)
 *
 * Event description: User or UoU delete a photo.
 *
 * @param {sharedGalleryDeleteParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {number} num_of_images_selected - num_of_images_selected
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {string} mode - expand / gallery (from which mode the photo was reported)
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @property {string} action_type - select all / multi select / single item
 * @return {LogObject<sharedGalleryDeleteParams>} LogObject<sharedGalleryDeleteParams>
 */
export function sharedGalleryDelete(params) {
    return { evid: 530, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryPhotoMenuClick' event (evid: 531)
 *
 * Event description: User or UoU click on the photo menu.
 *
 * @param {sharedGalleryPhotoMenuClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {string} mode - expand / gallery (from which mode the photo was reported)
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @return {LogObject<sharedGalleryPhotoMenuClickParams>} LogObject<sharedGalleryPhotoMenuClickParams>
 */
export function sharedGalleryPhotoMenuClick(params) {
    return { evid: 531, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDownloadPhoto' event (evid: 532)
 *
 * Event description: User or UoU download a photo.
 *
 * @param {sharedGalleryDownloadPhotoParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {number} num_of_images_selected - for multi select
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {string} mode - expand / gallery / members area
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @property {string} action_type - select all / multi select / single item
 * @return {LogObject<sharedGalleryDownloadPhotoParams>} LogObject<sharedGalleryDownloadPhotoParams>
 */
export function sharedGalleryDownloadPhoto(params) {
    return { evid: 532, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryViewAppPage' event (evid: 535)
 *
 * Event description: The app is viewed in the live site
 *
 * @param {sharedGalleryViewAppPageParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} albums_count - only in albums view
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - only in gallery view
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - gallery view / album view
 * @return {LogObject<sharedGalleryViewAppPageParams>} LogObject<sharedGalleryViewAppPageParams>
 */
export function sharedGalleryViewAppPage(params) {
    return { evid: 535, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryCreateAlbumClick' event (evid: 540)
 *
 * Event description: User or UoU create an album.
 *
 * @param {sharedGalleryCreateAlbumClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - comp_id
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - gallery view / albums view
 * @return {LogObject<sharedGalleryCreateAlbumClickParams>} LogObject<sharedGalleryCreateAlbumClickParams>
 */
export function sharedGalleryCreateAlbumClick(params) {
    return { evid: 540, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryNewAlbumCreated' event (evid: 541)
 *
 * Event description: New album created.
 *
 * @param {sharedGalleryNewAlbumCreatedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - comp_id
 * @property {boolean} is_description_added - is_description_added
 * @property {boolean} is_edited - false = if it's the first time the album was created, true = if edited and saved
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_name - The name of the album
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {boolean} is_cover_image_added - is_cover_image_added
 * @property {string} cover_image_id - photo_id of the cover image
 * @property {string} upload_photos - who can upload and tag: admins / all members / <custom_string>
 * @return {LogObject<sharedGalleryNewAlbumCreatedParams>} LogObject<sharedGalleryNewAlbumCreatedParams>
 */
export function sharedGalleryNewAlbumCreated(params) {
    return { evid: 541, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryMoveItem' event (evid: 542)
 *
 * Event description: User or UoU move item to different album.
 *
 * @param {sharedGalleryMoveItemParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - comp_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - new album id
 * @property {string} mode - expand / gallery (from which mode the photo was transferred)
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @property {string} old_album_id - old album id
 * @return {LogObject<sharedGalleryMoveItemParams>} LogObject<sharedGalleryMoveItemParams>
 */
export function sharedGalleryMoveItem(params) {
    return { evid: 542, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryShareAlbum' event (evid: 543)
 *
 * Event description: user or UoU shared an album
 *
 * @param {sharedGalleryShareAlbumParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - comp_id
 * @property {string} button_description - Share via social / copy link / invite to album
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_name - The name of the album
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<sharedGalleryShareAlbumParams>} LogObject<sharedGalleryShareAlbumParams>
 */
export function sharedGalleryShareAlbum(params) {
    return { evid: 543, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDeleteAlbum' event (evid: 544)
 *
 * Event description: user or UoU delete an album
 *
 * @param {sharedGalleryDeleteAlbumParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {number} num_of_images_deleted - num_of_images_deleted
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_name - The name of the album
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<sharedGalleryDeleteAlbumParams>} LogObject<sharedGalleryDeleteAlbumParams>
 */
export function sharedGalleryDeleteAlbum(params) {
    return { evid: 544, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGallerySortByAlbum' event (evid: 545)
 *
 * Event description: user or UoU sort by (album)
 *
 * @param {sharedGallerySortByAlbumParams} params - The parameters for this event
 * @property {GUID} instance_id - comp_id
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} sort_by - Recent Activity / Album Name (A-Z) / Most tagged members / Most Comments
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<sharedGallerySortByAlbumParams>} LogObject<sharedGallerySortByAlbumParams>
 */
export function sharedGallerySortByAlbum(params) {
    return { evid: 545, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryAlbumMenuClick' event (evid: 546)
 *
 * Event description: User or UoU click on the album menu.
 *
 * @param {sharedGalleryAlbumMenuClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - comp_id
 * @property {string} button_description - edit / download / share / delete
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_name - The name of the album
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - gallery view / albums view
 * @return {LogObject<sharedGalleryAlbumMenuClickParams>} LogObject<sharedGalleryAlbumMenuClickParams>
 */
export function sharedGalleryAlbumMenuClick(params) {
    return { evid: 546, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryCommentReplyAdded' event (evid: 548)
 *
 * Event description: User or UoU post a comment / reply.
 *
 * @param {sharedGalleryCommentReplyAddedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - photo_id of the comment
 * @property {string} has_media - Camera / Media Gallery / GIF
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - unique id for every comment.
 * @property {string} album_id - album_id of the comment
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment - (for reply)
 * @return {LogObject<sharedGalleryCommentReplyAddedParams>} LogObject<sharedGalleryCommentReplyAddedParams>
 */
export function sharedGalleryCommentReplyAdded(params) {
    return { evid: 548, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryLikeComment' event (evid: 549)
 *
 * Event description: User or UoU like a comment
 *
 * @param {sharedGalleryLikeCommentParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {string} role - role
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - photo_id of the comment
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - unique id for every comment.
 * @property {string} album_id - album_id of the comment
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment - (for reply)
 * @return {LogObject<sharedGalleryLikeCommentParams>} LogObject<sharedGalleryLikeCommentParams>
 */
export function sharedGalleryLikeComment(params) {
    return { evid: 549, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryOpenAlbumClick' event (evid: 551)
 *
 * Event description: When clicking on album and open it
 *
 * @param {sharedGalleryOpenAlbumClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - comp_id
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_name - The name of the album
 * @property {string} album_id - unique id for each album
 * @property {string} origin - albums_list / my_albums_carousel
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<sharedGalleryOpenAlbumClickParams>} LogObject<sharedGalleryOpenAlbumClickParams>
 */
export function sharedGalleryOpenAlbumClick(params) {
    return { evid: 551, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDownloadAlbum' event (evid: 552)
 *
 * Event description: user or UoU download an album
 *
 * @param {sharedGalleryDownloadAlbumParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - comp_id
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_name - The name of the album
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<sharedGalleryDownloadAlbumParams>} LogObject<sharedGalleryDownloadAlbumParams>
 */
export function sharedGalleryDownloadAlbum(params) {
    return { evid: 552, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryBackOfficeLoaded' event (evid: 560)
 *
 * Event description: When the back office of shared gallery is Loaded
 *
 * @param {sharedGalleryBackOfficeLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} albums_count - only on albums mode
 * @property {string} album_id - album_id
 * @property {string} comp_id - --
 * @property {string} app_id - app_id
 * @property {string} type - gallery view / album view
 * @property {string} instance_id - app comp id
 * @return {LogObject<sharedGalleryBackOfficeLoadedParams>} LogObject<sharedGalleryBackOfficeLoadedParams>
 */
export function sharedGalleryBackOfficeLoaded(params) {
    return { evid: 560, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryBackOfficeLinkClicked' event (evid: 561)
 *
 * Event description: When the user clicks on the "Learn more about Shared Gallery" link in the Back Office
 *
 * @param {sharedGalleryBackOfficeLinkClickedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {string} link_description - learn_more
 * @property {GUID} biToken - msid
 * @property {string} comp_id - --
 * @property {string} app_id - app_id
 * @property {string} instance_id - app comp id
 * @return {LogObject<sharedGalleryBackOfficeLinkClickedParams>} LogObject<sharedGalleryBackOfficeLinkClickedParams>
 */
export function sharedGalleryBackOfficeLinkClicked(params) {
    return { evid: 561, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDeleteAllPhotosClick' event (evid: 562)
 *
 * Event description: When the user clicks on the button 'Delete All' to reset his gallery from the settings
 *
 * @param {sharedGalleryDeleteAllPhotosClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<sharedGalleryDeleteAllPhotosClickParams>} LogObject<sharedGalleryDeleteAllPhotosClickParams>
 */
export function sharedGalleryDeleteAllPhotosClick(params) {
    return { evid: 562, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryAllPhotosDeleted' event (evid: 563)
 *
 * Event description: When the user Deleted All the photos to reset his gallery from the settings
 *
 * @param {sharedGalleryAllPhotosDeletedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<sharedGalleryAllPhotosDeletedParams>} LogObject<sharedGalleryAllPhotosDeletedParams>
 */
export function sharedGalleryAllPhotosDeleted(params) {
    return { evid: 563, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryViewOnSite' event (evid: 564)
 *
 * Event description: Shared Gallery -> View on site.
 *
 * @param {sharedGalleryViewOnSiteParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {boolean} is_image - is_image
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {string} album_id - album_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - photo_name
 * @property {string} instance_id - instance_id
 * @return {LogObject<sharedGalleryViewOnSiteParams>} LogObject<sharedGalleryViewOnSiteParams>
 */
export function sharedGalleryViewOnSite(params) {
    return { evid: 564, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryViewAlbumOnSite' event (evid: 565)
 *
 * Event description: Shared Gallery -> View Album On Site.
 *
 * @param {sharedGalleryViewAlbumOnSiteParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {string} album_name - The name of the album
 * @property {string} album_id - unique id for each album
 * @property {GUID} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<sharedGalleryViewAlbumOnSiteParams>} LogObject<sharedGalleryViewAlbumOnSiteParams>
 */
export function sharedGalleryViewAlbumOnSite(params) {
    return { evid: 565, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryAltTextSaved' event (evid: 566)
 *
 * Event description: When adding alt text to a photo.
 *
 * @param {sharedGalleryAltTextSavedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} instance_id - instance_id
 * @property {boolean} is_image - True if it's image and False if it's video
 * @property {string} role - who does the ‘action’ = member/admin/moderator/<custom_string>
 * @property {GUID} biToken - msid
 * @property {GUID} photo_id - unique id for each photo
 * @property {GUID} visitor_id - visitor_id
 * @property {string} album_id - unique id for each album
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} photo_name - The name of the file
 * @return {LogObject<sharedGalleryAltTextSavedParams>} LogObject<sharedGalleryAltTextSavedParams>
 */
export function sharedGalleryAltTextSaved(params) {
    return { evid: 566, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryManageMediaClick' event (evid: 567)
 *
 * Event description: when a user clicks on manage media in the editor settings
 *
 * @param {sharedGalleryManageMediaClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<sharedGalleryManageMediaClickParams>} LogObject<sharedGalleryManageMediaClickParams>
 */
export function sharedGalleryManageMediaClick(params) {
    return { evid: 567, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryReorderAlbumClick' event (evid: 568)
 *
 * Event description: User clicks on reorder album button
 *
 * @param {sharedGalleryReorderAlbumClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} num_of_albums - num_of_albums
 * @property {GUID} app_id - app_id
 * @property {string} type - albums view
 * @property {string} instance_id - comp_id
 * @return {LogObject<sharedGalleryReorderAlbumClickParams>} LogObject<sharedGalleryReorderAlbumClickParams>
 */
export function sharedGalleryReorderAlbumClick(params) {
    return { evid: 568, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryReorderAlbumModalOpen' event (evid: 569)
 *
 * Event description: Reorder Album modal open
 *
 * @param {sharedGalleryReorderAlbumModalOpenParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} num_of_albums - num_of_albums
 * @property {GUID} app_id - app_id
 * @property {string} type - albums view
 * @property {string} instance_id - comp_id
 * @return {LogObject<sharedGalleryReorderAlbumModalOpenParams>} LogObject<sharedGalleryReorderAlbumModalOpenParams>
 */
export function sharedGalleryReorderAlbumModalOpen(params) {
    return { evid: 569, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryReorderAlbumSave' event (evid: 570)
 *
 * Event description: Reorder Albums saved
 *
 * @param {sharedGalleryReorderAlbumSaveParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {boolean} is_reset - if it was saved through the regular save or the reset button
 * @property {number} num_of_albums - num_of_albums
 * @property {GUID} app_id - app_id
 * @property {string} type - albums view
 * @property {string} instance_id - comp_id
 * @return {LogObject<sharedGalleryReorderAlbumSaveParams>} LogObject<sharedGalleryReorderAlbumSaveParams>
 */
export function sharedGalleryReorderAlbumSave(params) {
    return { evid: 570, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'refineActionClickSrc63Evid6' event (evid: 6)
 *
 * Event description: Choice of specific changes
 *
 * @param {refineActionClickSrc63Evid6Params} params - The parameters for this event
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @property {string} changeName - Refine settings click: make_shorter, make_longer, change_tone, ...
 * @property {string} detailes - Dropdown selection or text
 * @return {LogObject<refineActionClickSrc63Evid6Params>} LogObject<refineActionClickSrc63Evid6Params>
 */
export function refineActionClickSrc63Evid6(params) {
    return { evid: 6, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksOpenWindowInSetup' event (evid: 600)
 *
 * Event description: Window opened in setup
 *
 * @param {quickBooksOpenWindowInSetupParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {string} description - Which window opened
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksOpenWindowInSetupParams>} LogObject<quickBooksOpenWindowInSetupParams>
 */
export function quickBooksOpenWindowInSetup(params) {
    return { evid: 600, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'deleteCommentReply' event (evid: 6003)
 *
 * Event description: User or UoU delete a Comment /Reply
 *
 * @param {deleteCommentReplyParams} params - The parameters for this event
 * @property {GUID} action_id - optional unique id for an action of user on the app (simillar on the same client event)
 * @property {GUID} parent_comment_id - the id of the parent comment - if reply so null
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} uuid - uuid
 * @property {string} container_id - unique id of the application container
 * @property {GUID} comment_id - unique id for every comment
 * @property {string} app_instance_id - app instance id - of the parent app
 * @property {string} container_type - type of the application container
 * @property {string} entity_id - unique id of the component
 * @property {string} app_id - of the parent app
 * @property {GUID} msid - msid
 * @property {string} by_commentor - True if deleted by the commentor and False if deleted by admin.
 * @return {LogObject<deleteCommentReplyParams>} LogObject<deleteCommentReplyParams>
 */
export function deleteCommentReply(params) {
    return { evid: 6003, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'likeCommentReply' event (evid: 6005)
 *
 * Event description: User or UoU like a Comment /Reply
 *
 * @param {likeCommentReplyParams} params - The parameters for this event
 * @property {GUID} action_id - optional unique id for an action of user on the app (simillar on the same client event)
 * @property {GUID} parent_comment_id - the id of the parent comment - if reply so null
 * @property {GUID} uuid - uuid
 * @property {string} container_id - unique id of the application container
 * @property {GUID} comment_id - unique id for every comment
 * @property {string} app_instance_id - app instance id - of the parent app
 * @property {string} container_type - type of the application container
 * @property {string} entity_id - unique id of the component
 * @property {string} app_id - of the parent app
 * @property {GUID} msid - msid
 * @return {LogObject<likeCommentReplyParams>} LogObject<likeCommentReplyParams>
 */
export function likeCommentReply(params) {
    return { evid: 6005, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'feedNewPostPublished' event (evid: 6007)
 *
 * Event description: When a post created and is successfully written to the server
 *
 * @param {feedNewPostPublishedParams} params - The parameters for this event
 * @property {string} containerType - Social Group etc
 * @property {number} count_galleries - number of galleries
 * @property {number} count_images - number of images in post
 * @property {GUID} uuid - uuid
 * @property {GUID} feedItemId - PostId
 * @property {number} count_files - number of files in post
 * @property {string} activityType - (if post ty is 'activity post') activity type
 * @property {string} userClass - Group/Event Owner or Member
 * @property {string} hostAppDefId - Container App
 * @property {number} count_videos - number of videos in post
 * @property {number} count_polls - number of polls in post
 * @property {string} postType - post type (null if usual posts, 'activity post', etc)
 * @property {number} count_mentions - number of mentions in post
 * @property {number} length - length of post
 * @property {GUID} containerId - GroupId / EventId etc
 * @property {number} count_gifs - number of gifs in post
 * @property {boolean} publishedByAppDefId - (optional) true if it's an automatic post, else false
 * @property {GUID} msid - msid
 * @return {LogObject<feedNewPostPublishedParams>} LogObject<feedNewPostPublishedParams>
 */
export function feedNewPostPublished(params) {
    return { evid: 6007, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'feedNewReactionAdded' event (evid: 6008)
 *
 * Event description: When a reaction is added and is successfully written to the server
 *
 * @param {feedNewReactionAddedParams} params - The parameters for this event
 * @property {string} containerType - Social Groups etc
 * @property {GUID} uuid - uuid
 * @property {GUID} feedItemId - post/comment feed_item_id if comment/reaction on post
 * @property {string} reactionType - type of reaction: smile/heart/lol etc
 * @property {string} userClass - Group/Event Owner or Member
 * @property {string} hostAppDefId - Groups/Events etc
 * @property {GUID} containerId - GroupId/EventId
 * @property {boolean} publishedByAppDefId - (optional) true if it's an automatic post, else false
 * @property {GUID} msid - msid
 * @return {LogObject<feedNewReactionAddedParams>} LogObject<feedNewReactionAddedParams>
 */
export function feedNewReactionAdded(params) {
    return { evid: 6008, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksClickOnButtonInFirstSetupWindow' event (evid: 601)
 *
 * Event description: User click on any button in the first setup window.
 *
 * @param {quickBooksClickOnButtonInFirstSetupWindowParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {string} description - 'Sign In To QuickBooks' / 'Create New Account' / 'Learn More'
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksClickOnButtonInFirstSetupWindowParams>} LogObject<quickBooksClickOnButtonInFirstSetupWindowParams>
 */
export function quickBooksClickOnButtonInFirstSetupWindow(params) {
    return { evid: 601, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksUserConnected' event (evid: 602)
 *
 * Event description: User connect account.
 *
 * @param {quickBooksUserConnectedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksUserConnectedParams>} LogObject<quickBooksUserConnectedParams>
 */
export function quickBooksUserConnected(params) {
    return { evid: 602, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksOnlineIncomeAccount' event (evid: 603)
 *
 * Event description: User select online income account.
 *
 * @param {quickBooksOnlineIncomeAccountParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {string} income_account - QuickBooks online income account that the user select
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksOnlineIncomeAccountParams>} LogObject<quickBooksOnlineIncomeAccountParams>
 */
export function quickBooksOnlineIncomeAccount(params) {
    return { evid: 603, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksPaymentMethodsMatch' event (evid: 604)
 *
 * Event description: User connect account.
 *
 * @param {quickBooksPaymentMethodsMatchParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} payment_methods_number - amount of payments methods
 * @property {string} payment_methods_details - all accounts  and payment methods in this format: 'payment_method_wix_1,payment_method_quickbooks_1 ; payment_method_wix_2,payment_method_wix_2; ...' if one of them is 'Manual' so write - '... ; Manual'
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksPaymentMethodsMatchParams>} LogObject<quickBooksPaymentMethodsMatchParams>
 */
export function quickBooksPaymentMethodsMatch(params) {
    return { evid: 604, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksStartManuallySync' event (evid: 605)
 *
 * Event description: User start initial sync (During Setup)
 *
 * @param {quickBooksStartManuallySyncParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} biToken - msid
 * @property {DateTime} sync_from_date - the date that the user choose to sync from
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} origin - --Deprecated
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksStartManuallySyncParams>} LogObject<quickBooksStartManuallySyncParams>
 */
export function quickBooksStartManuallySync(params) {
    return { evid: 605, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksManuallySyncSuccess' event (evid: 606)
 *
 * Event description: Initial sync success
 *
 * @param {quickBooksManuallySyncSuccessParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {string} sync_id - unique id for every sync
 * @property {GUID} biToken - msid
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksManuallySyncSuccessParams>} LogObject<quickBooksManuallySyncSuccessParams>
 */
export function quickBooksManuallySyncSuccess(params) {
    return { evid: 606, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksUserDisconnect' event (evid: 607)
 *
 * Event description: User click on Yes in Disconnect window.
 *
 * @param {quickBooksUserDisconnectParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} origin - from which page the user disconnected
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksUserDisconnectParams>} LogObject<quickBooksUserDisconnectParams>
 */
export function quickBooksUserDisconnect(params) {
    return { evid: 607, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksQuitSetup' event (evid: 608)
 *
 * Event description: User click on Yes in quit window from setup
 *
 * @param {quickBooksQuitSetupParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} origin - from which page the user quit
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksQuitSetupParams>} LogObject<quickBooksQuitSetupParams>
 */
export function quickBooksQuitSetup(params) {
    return { evid: 608, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksClientErrors' event (evid: 609)
 *
 * Event description: User get client error.
 *
 * @param {quickBooksClientErrorsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {string} sync_id - unique id of the sync
 * @property {GUID} biToken - msid
 * @property {number} error_id - error numbers that relevant for the page.
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} error_description - --Deprecated
 * @property {string} error_code - --Deprecated
 * @property {string} instance_id - instance_id
 * @property {string} error_name - explaination of the error number (from the errors doc - issue column)
 * @return {LogObject<quickBooksClientErrorsParams>} LogObject<quickBooksClientErrorsParams>
 */
export function quickBooksClientErrors(params) {
    return { evid: 609, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksStatusWindowDisplay' event (evid: 610)
 *
 * Event description: Status window display
 *
 * @param {quickBooksStatusWindowDisplayParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {DateTime} next_sync - --Deprecated
 * @property {GUID} biToken - msid
 * @property {string} error_page_type - A, B, C, D, E (if status = false)
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {boolean} status - if the status page is OK or the user get error page.
 * @property {DateTime} last_sync - only if user get error - date of the last sync that failed.
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksStatusWindowDisplayParams>} LogObject<quickBooksStatusWindowDisplayParams>
 */
export function quickBooksStatusWindowDisplay(params) {
    return { evid: 610, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksStartManualSyncAfterError' event (evid: 611)
 *
 * Event description: User Sync after error
 *
 * @param {quickBooksStartManualSyncAfterErrorParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} realm_id - unique id of user in QB
 * @property {string} origin - from which error page - A / B / C / D / E
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksStartManualSyncAfterErrorParams>} LogObject<quickBooksStartManualSyncAfterErrorParams>
 */
export function quickBooksStartManualSyncAfterError(params) {
    return { evid: 611, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksManualSyncAfterErrorSuccess' event (evid: 612)
 *
 * Event description: Manual Sync (After Error) - Success
 *
 * @param {quickBooksManualSyncAfterErrorSuccessParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} realm_id - unique id of user in QB
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksManualSyncAfterErrorSuccessParams>} LogObject<quickBooksManualSyncAfterErrorSuccessParams>
 */
export function quickBooksManualSyncAfterErrorSuccess(params) {
    return { evid: 612, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksClientErrorQbApiError' event (evid: 613)
 *
 * Event description: Client API error
 *
 * @param {quickBooksClientErrorQbApiErrorParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} error_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} error_ids - error numbers that relevant for the page
 * @property {string} instance_id - instance_id
 * @property {string} error_name - explaination of the error number (from the errors doc - issue column)
 * @return {LogObject<quickBooksClientErrorQbApiErrorParams>} LogObject<quickBooksClientErrorQbApiErrorParams>
 */
export function quickBooksClientErrorQbApiError(params) {
    return { evid: 613, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksClientErrorMappingErrors' event (evid: 614)
 *
 * Event description: Client Error - Mapping errors
 *
 * @param {quickBooksClientErrorMappingErrorsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} realm_id - unique id of user in QB
 * @property {string} error_ids - string holding the errors codes separated by ;
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksClientErrorMappingErrorsParams>} LogObject<quickBooksClientErrorMappingErrorsParams>
 */
export function quickBooksClientErrorMappingErrors(params) {
    return { evid: 614, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksCountryNotSupported' event (evid: 615)
 *
 * Event description: Country not supported
 *
 * @param {quickBooksCountryNotSupportedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} realm_id - unique id of user in QB
 * @property {string} currency - currency
 * @property {string} instance_id - instance_id
 * @return {LogObject<quickBooksCountryNotSupportedParams>} LogObject<quickBooksCountryNotSupportedParams>
 */
export function quickBooksCountryNotSupported(params) {
    return { evid: 615, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksStartSync' event (evid: 620)
 *
 * Event description: the server start the syncing process.
 * 4 cases:
 * 1.  Inital sync suring Setup (Batch sync)
 * 2. Auto sync -sync 1 transaction
 * 3. Scheduled sync
 * 4. Manual sync after Error (Batch sync)
 *
 * @param {quickBooksStartSyncParams} params - The parameters for this event
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event). only if the sync was initiated by the client. otherwise send empty.
 * @property {string} sync_id - unique id for every sync
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {boolean} is_manually - --Deprecated
 * @property {DateTime} sync_from_date - --Deprecated
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} origin - initial / Auto / scheduled / Manual
 * @property {string} instance_id - app comp id
 * @return {LogObject<quickBooksStartSyncParams>} LogObject<quickBooksStartSyncParams>
 */
export function quickBooksStartSync(params) {
    return { evid: 620, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksSyncIsDone' event (evid: 621)
 *
 * Event description: the server complete the syncing process.  whether is succeeded or failed.
 *
 * @param {quickBooksSyncIsDoneParams} params - The parameters for this event
 * @property {number} number_of_transactions - how namy transactions in the sync.
 * @property {string} sync_id - unique id for every sync.
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} error_id - --Deprecated
 * @property {DateTime} sync_from_date - --Deprecated
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} origin - initial / auto / scheduled / manual
 * @property {string} error_description - --Deprecated
 * @property {string} error_code - --Deprecated
 * @property {string} instance_id - app comp id
 * @property {string} error_name - --Deprecated
 * @property {boolean} sync_successful - whether or not the sync succeeds.
 * @return {LogObject<quickBooksSyncIsDoneParams>} LogObject<quickBooksSyncIsDoneParams>
 */
export function quickBooksSyncIsDone(params) {
    return { evid: 621, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksTransactionDetails' event (evid: 622)
 *
 * Event description: Transaction synced to QB
 *
 * @param {quickBooksTransactionDetailsParams} params - The parameters for this event
 * @property {string} order_id - unique id for order.
 * @property {string} tax_case - didn't setup in Wix / didn't setup in QB / user setup the tax in QB api CASE 1 - didn't setup in Wix = didn't get tax from cashier api ; CASE 2 - didn't setup in QB - we get null from QB api ; CASE 3 - user setup the tax in QB api) -based on WIXLABS-5147
 * @property {number} number_of_products - the total products per transaction
 * @property {string} sync_id - unique id for sync.
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {string} transaction_status - transaction_status
 * @property {number} amount - the amount of money per transaction
 * @property {number} relm_id - --Deprecated
 * @property {string} qb_payment_method - QB payment method.
 * @property {string} consumer - the wix app on the user site who send the transactions
 * @property {string} transaction_id - unique id for transaction
 * @property {number} realm_id - unique id of user in QB
 * @property {DateTime} transaction_real_date - the date of the transaction in the server
 * @property {string} currency - the currency of the transaction
 * @property {number} total_tax - total tax
 * @property {string} transaction_type - transaction_type
 * @property {string} discount - discount
 * @property {number} total_amount - total amount after calculation
 * @property {string} instance_id - app comp id
 * @property {boolean} transaction_successful - whether or not the transaction succeeds
 * @property {string} wix_payment_method - wix payment method of the transaction
 * @property {number} shipping - additional charges for shipping
 * @return {LogObject<quickBooksTransactionDetailsParams>} LogObject<quickBooksTransactionDetailsParams>
 */
export function quickBooksTransactionDetails(params) {
    return { evid: 622, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksHoldOnStatus' event (evid: 623)
 *
 * Event description: Sync Status Change (See product brief - https://2947em.axshare.com/#g=1&p=sync_-_on_hold)
 *
 * @param {quickBooksHoldOnStatusParams} params - The parameters for this event
 * @property {string} old_status - setup / active / error / on hold
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} relm_id - --Deprecated
 * @property {number} realm_id - unique id of user in QB
 * @property {string} new_status - setup / active / error / on hold
 * @property {string} instance_id - app comp id
 * @return {LogObject<quickBooksHoldOnStatusParams>} LogObject<quickBooksHoldOnStatusParams>
 */
export function quickBooksHoldOnStatus(params) {
    return { evid: 623, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksSyncIsReactivated' event (evid: 624)
 *
 * Event description: Sync is reactivated
 *
 * @param {quickBooksSyncIsReactivatedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} relm_id - unique id of user in QB
 * @property {string} instance_id - app comp id
 * @return {LogObject<quickBooksSyncIsReactivatedParams>} LogObject<quickBooksSyncIsReactivatedParams>
 */
export function quickBooksSyncIsReactivated(params) {
    return { evid: 624, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksSyncError' event (evid: 625)
 *
 * Event description: Sync Error Details
 *
 * @param {quickBooksSyncErrorParams} params - The parameters for this event
 * @property {string} sync_id - unique id of the sync
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} error_id - error numbers that relevant for the page
 * @property {string} transaction_id - unique id of the transaction the sync failed in (IF)
 * @property {number} realm_id - unique id of user in QB
 * @property {string} error_description - additional info on the error (if this is 'country not supported' error so send the country code)
 * @property {string} error_code - external error code
 * @property {string} error_name - explanation of the error number (from the errors doc - issue column)
 * @return {LogObject<quickBooksSyncErrorParams>} LogObject<quickBooksSyncErrorParams>
 */
export function quickBooksSyncError(params) {
    return { evid: 625, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksWebhookSentForTransaction' event (evid: 627)
 *
 * Event description: Webhook sent for transaction that was already synced. Got Webhook -> check DB to see if it was already synced -> it was already synced
 *
 * @param {quickBooksWebhookSentForTransactionParams} params - The parameters for this event
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {string} transaction_id - unique id of the transaction
 * @property {number} realm_id - unique id of user in QB
 * @return {LogObject<quickBooksWebhookSentForTransactionParams>} LogObject<quickBooksWebhookSentForTransactionParams>
 */
export function quickBooksWebhookSentForTransaction(params) {
    return { evid: 627, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'quickBooksSubscriptionStatusChanged' event (evid: 628)
 *
 * Event description: When the user connect to QB - check subscription status - if it changed send BI event
 *
 * @param {quickBooksSubscriptionStatusChangedParams} params - The parameters for this event
 * @property {string} old_status - TRIAL / TRIALOPTIN / EXPIRED / SUBSCRIBED / RESTRICTED / SUSPENDED / CANCELLED / UNKNOWN
 * @property {GUID} app_site_id - app instance id
 * @property {GUID} biToken - msid
 * @property {number} realm_id - unique id of user in QB
 * @property {string} new_status - TRIAL / TRIALOPTIN / EXPIRED / SUBSCRIBED / RESTRICTED / SUSPENDED / CANCELLED / UNKNOWN
 * @return {LogObject<quickBooksSubscriptionStatusChangedParams>} LogObject<quickBooksSubscriptionStatusChangedParams>
 */
export function quickBooksSubscriptionStatusChanged(params) {
    return { evid: 628, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsPost' event (evid: 630)
 *
 * Event description: User or UoU post a comment / reply.
 *
 * @param {commentsPostParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {number} image_count - number of images in the comment
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - app_id of the parent app
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {string} has_media - Camera / Media Gallery / GIF.
 * @property {GUID} visitor_id - visitor_id
 * @property {string} permissions - Viewer / Writer / Admin.
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component (post_id. photo_id, etc..))
 * @property {number} gif_count - number of gifs in the comment
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment (L1) - if reply so null.
 * @property {number} video_count - number of videos in the comment
 * @property {number} emoji_count - number of emoji in the comment
 * @return {LogObject<commentsPostParams>} LogObject<commentsPostParams>
 */
export function commentsPost(params) {
    return { evid: 630, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsDelete' event (evid: 631)
 *
 * Event description: User or UoU delete a comment / reply.
 *
 * @param {commentsDeleteParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - app_id of the parent app
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} by_user - True if deleted by user and False if deleted by admin.
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment (L1) - if reply so null.
 * @return {LogObject<commentsDeleteParams>} LogObject<commentsDeleteParams>
 */
export function commentsDelete(params) {
    return { evid: 631, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsReport' event (evid: 632)
 *
 * Event description: User or UoU report a comment / reply.
 *
 * @param {commentsReportParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - app_id of the parent app
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment (L1) - if reply so null.
 * @property {string} report_reason - one of the four options given.
 * @return {LogObject<commentsReportParams>} LogObject<commentsReportParams>
 */
export function commentsReport(params) {
    return { evid: 632, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsShare' event (evid: 633)
 *
 * Event description: User or UoU share a comment / reply.
 *
 * @param {commentsShareParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - app_id of the parent app
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment (L1) - if reply so null.
 * @return {LogObject<commentsShareParams>} LogObject<commentsShareParams>
 */
export function commentsShare(params) {
    return { evid: 633, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsLike' event (evid: 634)
 *
 * Event description: User or UoU like a comment / reply.
 *
 * @param {commentsLikeParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - app_id of the parent app
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment (L1) - if reply so null.
 * @return {LogObject<commentsLikeParams>} LogObject<commentsLikeParams>
 */
export function commentsLike(params) {
    return { evid: 634, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsPreviousComments' event (evid: 635)
 *
 * Event description: show previous comment
 *
 * @param {commentsPreviousCommentsParams} params - The parameters for this event
 * @property {GUID} instance_id - instance id
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - app_id of the parent app
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor id
 * @property {number} number_of_comments - number of comments in page
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment - if reply so null.
 * @return {LogObject<commentsPreviousCommentsParams>} LogObject<commentsPreviousCommentsParams>
 */
export function commentsPreviousComments(params) {
    return { evid: 635, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsLoaded' event (evid: 636)
 *
 * Event description: Comments section was loaded.
 *
 * @param {commentsLoadedParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} app_site_id - app id of the hosting tpa
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app id
 * @return {LogObject<commentsLoadedParams>} LogObject<commentsLoadedParams>
 */
export function commentsLoaded(params) {
    return { evid: 636, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsMention' event (evid: 637)
 *
 * Event description: User or UoU mention a member in a comment / reply or clicked on it
 *
 * @param {commentsMentionParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - parent_app_id
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment (L1) - if reply so null.
 * @property {string} type - added (comment/reply was published with mention) / clicked (by uou)
 * @property {GUID} mention_visitor_id - The id of the member that was mentioned in the comment / reply
 * @return {LogObject<commentsMentionParams>} LogObject<commentsMentionParams>
 */
export function commentsMention(params) {
    return { evid: 637, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsShowMoreReplies' event (evid: 638)
 *
 * Event description: Comments -> Show More Replies.
 *
 * @param {commentsShowMoreRepliesParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} item_id - item_id
 * @property {GUID} action_id - action_id
 * @property {GUID} parent_app_id - parent_app_id
 * @property {number} comment_level - comment_level
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} number_of_comments - ---Deprecated---
 * @property {string} comment_id - comment_id
 * @property {string} entity_id - entity_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - parent_comment
 * @return {LogObject<commentsShowMoreRepliesParams>} LogObject<commentsShowMoreRepliesParams>
 */
export function commentsShowMoreReplies(params) {
    return { evid: 638, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'commentsAddReplyClick' event (evid: 639)
 *
 * Event description: User or UoU wants to add a reply to a comment by clicking on reply button or starting to write in the reply box
 *
 * @param {commentsAddReplyClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} item_id - ---Deprecated---
 * @property {GUID} action_id - unique id for an action of user on the app (simillar on the same client event).
 * @property {GUID} parent_app_id - app_id of the parent app
 * @property {number} comment_level - The level of the comment or the reply
 * @property {GUID} app_site_id - app instance id of the parent app
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comment_id - unique id for every comment.
 * @property {string} entity_id - unique id of the component
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} parent_comment - the id of the parent comment (L1) - if reply so null.
 * @property {string} type - button / reply box
 * @return {LogObject<commentsAddReplyClickParams>} LogObject<commentsAddReplyClickParams>
 */
export function commentsAddReplyClick(params) {
    return { evid: 639, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsButtonClickSrc63Evid7' event (evid: 7)
 *
 * Event description: Open settings on panel
 *
 * @param {settingsButtonClickSrc63Evid7Params} params - The parameters for this event
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @return {LogObject<settingsButtonClickSrc63Evid7Params>} LogObject<settingsButtonClickSrc63Evid7Params>
 */
export function settingsButtonClickSrc63Evid7(params) {
    return { evid: 7, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryStartUploadingANewPhoto' event (evid: 700)
 *
 * Event description: start upload a new photo to the app
 *
 * @param {sharedGalleryStartUploadingANewPhotoParams} params - The parameters for this event
 * @property {GUID} item_id - unique id for any image
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {string} item_extension - item_extension
 * @property {GUID} album_id - unique id for any album
 * @property {GUID} site_member_id - unique id for member of the site
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<sharedGalleryStartUploadingANewPhotoParams>} LogObject<sharedGalleryStartUploadingANewPhotoParams>
 */
export function sharedGalleryStartUploadingANewPhoto(params) {
    return { evid: 700, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryCompleteUploadANewPhoto' event (evid: 701)
 *
 * Event description: complete upload a new photo to the app
 *
 * @param {sharedGalleryCompleteUploadANewPhotoParams} params - The parameters for this event
 * @property {GUID} item_id - unique id for any image
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {GUID} album_id - unique id for any album
 * @property {number} item_size - the size of the image
 * @property {GUID} site_member_id - unique id for member of the site
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<sharedGalleryCompleteUploadANewPhotoParams>} LogObject<sharedGalleryCompleteUploadANewPhotoParams>
 */
export function sharedGalleryCompleteUploadANewPhoto(params) {
    return { evid: 701, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDescribePhoto' event (evid: 702)
 *
 * Event description: user or UoU add a description to the photo
 *
 * @param {sharedGalleryDescribePhotoParams} params - The parameters for this event
 * @property {GUID} item_id - unique id for any image
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {GUID} album_id - unique id for any album
 * @property {GUID} site_member_id - unique id for member of the site
 * @property {string} owner - who is making the action
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<sharedGalleryDescribePhotoParams>} LogObject<sharedGalleryDescribePhotoParams>
 */
export function sharedGalleryDescribePhoto(params) {
    return { evid: 702, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryLikeSrc63Evid703' event (evid: 703)
 *
 * Event description: user or UoU click on love a photo
 *
 * @param {sharedGalleryLikeSrc63Evid703Params} params - The parameters for this event
 * @property {GUID} item_id - unique id for any image
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {GUID} album_id - unique id for any album
 * @property {boolean} is_new_like - True if it's a like and False if the click delete the like
 * @property {GUID} site_member_id - unique id for member of the site
 * @property {string} owner - who is making the action
 * @property {number} likes_count - number of likes
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<sharedGalleryLikeSrc63Evid703Params>} LogObject<sharedGalleryLikeSrc63Evid703Params>
 */
export function sharedGalleryLikeSrc63Evid703(params) {
    return { evid: 703, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryReportSrc63Evid704' event (evid: 704)
 *
 * Event description: UoU report on a photo.
 *
 * @param {sharedGalleryReportSrc63Evid704Params} params - The parameters for this event
 * @property {GUID} item_id - unique id for any image
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {GUID} album_id - unique id for any album
 * @property {GUID} site_member_id - unique id for member of the site
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @property {string} report_reason - report reason
 * @return {LogObject<sharedGalleryReportSrc63Evid704Params>} LogObject<sharedGalleryReportSrc63Evid704Params>
 */
export function sharedGalleryReportSrc63Evid704(params) {
    return { evid: 704, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sharedGalleryDeleteSrc63Evid705' event (evid: 705)
 *
 * Event description: user or UoU delete a photo
 *
 * @param {sharedGalleryDeleteSrc63Evid705Params} params - The parameters for this event
 * @property {GUID} item_id - unique id for any image
 * @property {GUID} action_id - action_id to join events on server and client side
 * @property {GUID} album_id - unique id for any album
 * @property {GUID} site_member_id - unique id for member of the site
 * @property {string} owner - who is making the action
 * @property {GUID} msid - msid
 * @property {GUID} instance_id - instance id
 * @return {LogObject<sharedGalleryDeleteSrc63Evid705Params>} LogObject<sharedGalleryDeleteSrc63Evid705Params>
 */
export function sharedGalleryDeleteSrc63Evid705(params) {
    return { evid: 705, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'tokenSentSrc63Evid8' event (evid: 8)
 *
 * Event description: Send request to the model
 *
 * @param {tokenSentSrc63Evid8Params} params - The parameters for this event
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @property {number} cost - Cost of the request
 * @property {string} inputTokens - Input value
 * @property {string} outputTokens - Output value
 * @property {string} request_api - Request type: generate_text | regenerate_text | make_longer
 * @property {string} generationResponse - Generation response
 * @property {string} generationRequest - Generation request
 * @return {LogObject<tokenSentSrc63Evid8Params>} LogObject<tokenSentSrc63Evid8Params>
 */
export function tokenSentSrc63Evid8(params) {
    return { evid: 8, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'moderationPending' event (evid: 802)
 *
 * Event description: Content Item submitted, entered the moderator queue and waiting for approval
 *
 * @param {moderationPendingParams} params - The parameters for this event
 * @property {string} item_id - content item id (comment id / post id ...)
 * @property {GUID} uuid - uuid
 * @property {string} parent_item_id - parent content item id (for example - if comment of blog post is the item, the parent will be the blog post id - one level higher in the hierarchy)
 * @property {GUID} app_instance_id - app instance id - of the parent app
 * @property {string} parent_item_type - post / folder/ album ...
 * @property {string} author_role - owner / member / visitor
 * @property {string} app_id - of the parent app
 * @property {GUID} author_id - the id of the member who submitted the content item
 * @property {GUID} moderation_id - unique id of the moderation session (the content item will have the same moderation id in the same cycle, if it will be declined and resubmit, it will have an new moderation id
 * @property {string} item_type - content item type (comment / post / image ...))
 * @property {GUID} msid - msid
 * @return {LogObject<moderationPendingParams>} LogObject<moderationPendingParams>
 */
export function moderationPending(params) {
    return { evid: 802, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'moderationApproved' event (evid: 803)
 *
 * Event description: Content Item approved by the moderator and published
 *
 * @param {moderationApprovedParams} params - The parameters for this event
 * @property {string} item_id - content item id (comment id / post id ...)
 * @property {GUID} uuid - uuid
 * @property {string} parent_item_id - parent content item id (for example - if comment of blog post is the item, the parent will be the blog post id - one level higher in the hierarchy)
 * @property {boolean} is_auto - True - automatic approve - only moderation rules, and doesn't need moderator approval / False - active approve by the moderator
 * @property {GUID} app_instance_id - app instance id - of the parent app
 * @property {string} parent_item_type - post / folder/ album ...
 * @property {string} author_role - owner / member / visitor
 * @property {string} app_id - of the parent app
 * @property {GUID} author_id - the id of the member who submitted the content item
 * @property {GUID} moderation_id - unique id of the moderation session (the content item will have the same moderation id in the same cycle, if it will be declined and resubmit, it will have an new moderation id
 * @property {string} item_type - content item type (comment / post / image ...))
 * @property {GUID} msid - msid
 * @return {LogObject<moderationApprovedParams>} LogObject<moderationApprovedParams>
 */
export function moderationApproved(params) {
    return { evid: 803, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'moderationDeclined' event (evid: 804)
 *
 * Event description: Content Item declined by the moderator and go back to drafts or deleted
 *
 * @param {moderationDeclinedParams} params - The parameters for this event
 * @property {string} item_id - content item id (comment id / post id ...)
 * @property {boolean} is_feedback - True - if declined with moderator feedback and requested changes  (note) / False - no feedback
 * @property {GUID} uuid - uuid
 * @property {string} parent_item_id - parent content item id (for example - if comment of blog post is the item, the parent will be the blog post id - one level higher in the hierarchy)
 * @property {GUID} app_instance_id - app instance id - of the parent app
 * @property {string} parent_item_type - post / folder/ album ...
 * @property {string} author_role - owner / member / visitor
 * @property {string} app_id - of the parent app
 * @property {GUID} author_id - the id of the member who submitted the content item
 * @property {GUID} moderation_id - unique id of the moderation session (the content item will have the same moderation id in the same cycle, if it will be declined and resubmit, it will have an new moderation id
 * @property {string} item_type - content item type (comment / post / image ...))
 * @property {GUID} msid - msid
 * @return {LogObject<moderationDeclinedParams>} LogObject<moderationDeclinedParams>
 */
export function moderationDeclined(params) {
    return { evid: 804, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'wixFaqDetailsMobileApp' event (evid: 819)
 *
 * Event description: Sending all the relevant app settings at save/publish of the site.
 * For different apps, wixlabs_boll/num/string params will be sent according to each app settings.
 *
 * @param {wixFaqDetailsMobileAppParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id (per app per site)
 * @property {boolean} wixlabs_bool_2 - show search bar
 * @property {GUID} site_id - site_id
 * @property {GUID} biToken - msid
 * @property {string} event_trigger - {'save', 'publish'}
 * @property {string} wixlabs_string_3 - number of FAQs to display
 * @property {boolean} wixlabs_bool_4 - open first answer
 * @property {boolean} wixlabs_bool_16 - show 'all categories' label
 * @property {boolean} wixlabs_bool_1 - show title
 * @property {boolean} wixlabs_bool_11 - show one answer at atime  (Toggle On = true, Toggle Off = false)
 * @property {number} wixlabs_num_2 - number of categories
 * @property {boolean} wixlabs_bool_15 - show category menu
 * @property {number} wixlabs_num_5 - number of categories chosen
 * @property {GUID} app_id - app_id
 * @property {number} wixlabs_num_1 - number of questions
 * @property {string} instance_id - instance_id
 * @return {LogObject<wixFaqDetailsMobileAppParams>} LogObject<wixFaqDetailsMobileAppParams>
 */
export function wixFaqDetailsMobileApp(params) {
    return { evid: 819, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqBackOfficeLoaded' event (evid: 820)
 *
 * Event description: FAQ -> Back Office loaded.
 *
 * @param {faqBackOfficeLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_demo_data - is demo data
 * @property {number} num_of_questions_in_chat - num_of_questions_in_chat
 * @property {number} num_of_categories - total number of categories
 * @property {string} origin - origin
 * @property {string} app_id - app_id
 * @property {number} num_of_questions - num_of_questions
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqBackOfficeLoadedParams>} LogObject<faqBackOfficeLoadedParams>
 */
export function faqBackOfficeLoaded(params) {
    return { evid: 820, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqAddQuestionClick' event (evid: 821)
 *
 * Event description: when the user clicks on add question (from categroy_menu / duplicate / top_page / chat_modal)
 *
 * @param {faqAddQuestionClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} button_description - categroy_menu / duplicate / top_page / chat_modal
 * @property {GUID} biToken - msid
 * @property {string} draft_question_id - draft_question_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqAddQuestionClickParams>} LogObject<faqAddQuestionClickParams>
 */
export function faqAddQuestionClick(params) {
    return { evid: 821, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqQuestionAddedEdited' event (evid: 822)
 *
 * Event description: when the users added a question (saved)
 *
 * @param {faqQuestionAddedEditedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {number} image_count - RCE - image_count
 * @property {boolean} is_edited - is_edited - false - new question / true - edit (to know if its published for the first time)
 * @property {GUID} biToken - msid
 * @property {number} youtube_count - RCE - youtube_count
 * @property {number} hashtag_count - RCE - hashtag_count
 * @property {number} map_count - RCE - map_count
 * @property {string} draft_question_id - draft_question_id
 * @property {string} form_origin - faq_bo / chat_modal
 * @property {number} mention_count - RCE - mention_count
 * @property {number} tiktok_count - RCE - tiktok_count
 * @property {string} question_id - question_id
 * @property {string} origin - editor / dashboard
 * @property {number} gif_count - RCE - gif_count
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {number} link_count - RCE - link_count
 * @property {number} video_count - RCE - video_count
 * @property {string} instance_id - comp_id
 * @property {number} twiter_count - RCE - twiter_count
 * @property {number} emoji_count - RCE - emoji_count
 * @property {number} instagram_count - RCE - instagram_count
 * @property {boolean} is_ai_generated - If question was generated by AI
 * @return {LogObject<faqQuestionAddedEditedParams>} LogObject<faqQuestionAddedEditedParams>
 */
export function faqQuestionAddedEdited(params) {
    return { evid: 822, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqEditQuestionClick' event (evid: 823)
 *
 * Event description: when the user clicks on edit question
 *
 * @param {faqEditQuestionClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} question_id - question_id
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqEditQuestionClickParams>} LogObject<faqEditQuestionClickParams>
 */
export function faqEditQuestionClick(params) {
    return { evid: 823, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqQuestionMenuClick3DotsMenu' event (evid: 824)
 *
 * Event description: when the user clicks on the question menu
 *
 * @param {faqQuestionMenuClick3DotsMenuParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} source - ---deprecated---
 * @property {string} button_description - duplicate / translate / share_link / delete / manage_chat_faq
 * @property {GUID} biToken - msid
 * @property {string} question_id - question_id
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqQuestionMenuClick3DotsMenuParams>} LogObject<faqQuestionMenuClick3DotsMenuParams>
 */
export function faqQuestionMenuClick3DotsMenu(params) {
    return { evid: 824, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqQuestionDeleted' event (evid: 825)
 *
 * Event description: when the user deletes a question (also when deleting a category - this event will be sent to all questions that were deleted under this category)
 *
 * @param {faqQuestionDeletedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} question_id - question_id
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqQuestionDeletedParams>} LogObject<faqQuestionDeletedParams>
 */
export function faqQuestionDeleted(params) {
    return { evid: 825, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqMoveQuestion' event (evid: 826)
 *
 * Event description: when the user moves a question from one category to another
 *
 * @param {faqMoveQuestionParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} old_category_id - old category_id
 * @property {string} question_id - question_id
 * @property {string} category_id - new category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqMoveQuestionParams>} LogObject<faqMoveQuestionParams>
 */
export function faqMoveQuestion(params) {
    return { evid: 826, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqAddCategoryClick' event (evid: 827)
 *
 * Event description: when the click on the add category button
 *
 * @param {faqAddCategoryClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} button_description - main_page / add_question_page / chat_modal
 * @property {GUID} biToken - msid
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqAddCategoryClickParams>} LogObject<faqAddCategoryClickParams>
 */
export function faqAddCategoryClick(params) {
    return { evid: 827, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqCategoryAddedEdited' event (evid: 828)
 *
 * Event description: when the user added or edited a category
 *
 * @param {faqCategoryAddedEditedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {boolean} is_edited - is_edited
 * @property {GUID} biToken - msid
 * @property {string} category_name - category_name
 * @property {string} origin_form - faq_bo / chat_modal
 * @property {string} origin - editor / dashboard
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @property {boolean} is_ai_generated - If category was created by AI
 * @return {LogObject<faqCategoryAddedEditedParams>} LogObject<faqCategoryAddedEditedParams>
 */
export function faqCategoryAddedEdited(params) {
    return { evid: 828, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqCategoryMenuClick3Dots' event (evid: 829)
 *
 * Event description: when the user clicks on the category 3 dots menu
 *
 * @param {faqCategoryMenuClick3DotsParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} button_description - add_question / rename_category / translate / delete
 * @property {GUID} biToken - msid
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqCategoryMenuClick3DotsParams>} LogObject<faqCategoryMenuClick3DotsParams>
 */
export function faqCategoryMenuClick3Dots(params) {
    return { evid: 829, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqCategoryDeleted' event (evid: 830)
 *
 * Event description: when the user deleted a category
 *
 * @param {faqCategoryDeletedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} num_of_questions_deleted - number of questions that was deleted under the category
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqCategoryDeletedParams>} LogObject<faqCategoryDeletedParams>
 */
export function faqCategoryDeleted(params) {
    return { evid: 830, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqMultilingualClick' event (evid: 831)
 *
 * Event description: when the user clicks on multilingual (top page / translate question / translate category
 *
 * @param {faqMultilingualClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {string} source - deprecated
 * @property {string} button_description - top_main_page / translate_question / translate_category
 * @property {GUID} biToken - msid
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqMultilingualClickParams>} LogObject<faqMultilingualClickParams>
 */
export function faqMultilingualClick(params) {
    return { evid: 831, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqChatClick' event (evid: 832)
 *
 * Event description: when the user clicks on chat -
 * 3 options:  manage (both installed and faq is toggled on in chat) / chat_not_installed / chat_installed_faq_toggled_off (chat is installed but faq is toggled off in chat )
 *
 * @param {faqChatClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {string} app_id - app_id
 * @property {string} type - manage (both installed and faq is toggled on in chat) / chat_not_installed / chat_installed_faq_toggled_off (chat is installed but faq is toggled off in chat )
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqChatClickParams>} LogObject<faqChatClickParams>
 */
export function faqChatClick(params) {
    return { evid: 832, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqChatModalOpened' event (evid: 833)
 *
 * Event description: when the chat modal is opened
 *
 * @param {faqChatModalOpenedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} num_of_categories - num_of_categories
 * @property {string} app_id - app_id
 * @property {number} num_of_questions - num_of_questions
 * @property {string} instance_id - comp_id
 * @property {number} num_of_questions_selected - selected to chat
 * @return {LogObject<faqChatModalOpenedParams>} LogObject<faqChatModalOpenedParams>
 */
export function faqChatModalOpened(params) {
    return { evid: 833, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqChatModalClosed' event (evid: 834)
 *
 * Event description: when the chat modal is closed
 *
 * @param {faqChatModalClosedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} num_of_categories - num_of_categories
 * @property {string} app_id - app_id
 * @property {number} num_of_questions - num_of_questions
 * @property {string} instance_id - comp_id
 * @property {number} num_of_questions_selected - selected to chat
 * @return {LogObject<faqChatModalClosedParams>} LogObject<faqChatModalClosedParams>
 */
export function faqChatModalClosed(params) {
    return { evid: 834, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqChatModalQuestionSelected' event (evid: 835)
 *
 * Event description: when saving the modal, this event is fired for each question that was selceted
 *
 * @param {faqChatModalQuestionSelectedParams} params - The parameters for this event
 * @property {GUID} app_site_id - instance_id
 * @property {GUID} biToken - msid
 * @property {boolean} is_first - is this the first time this question was added to chat
 * @property {string} question_id - question_id
 * @property {string} category_id - category_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqChatModalQuestionSelectedParams>} LogObject<faqChatModalQuestionSelectedParams>
 */
export function faqChatModalQuestionSelected(params) {
    return { evid: 835, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqButtonClickSrc63Evid836' event (evid: 836)
 *
 * Event description: FAQ -> button click
 *
 * @param {faqButtonClickSrc63Evid836Params} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {string} button_name - link_name or tab_name
 * @property {string} action - link or tab
 * @return {LogObject<faqButtonClickSrc63Evid836Params>} LogObject<faqButtonClickSrc63Evid836Params>
 */
export function faqButtonClickSrc63Evid836(params) {
    return { evid: 836, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqManageQuestionsClick' event (evid: 850)
 *
 * Event description: when a user clicks on manage question in the editor settings
 *
 * @param {faqManageQuestionsClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} comp_id - comp_id
 * @property {string} app_id - app_id
 * @property {string} instance_id - comp_id
 * @return {LogObject<faqManageQuestionsClickParams>} LogObject<faqManageQuestionsClickParams>
 */
export function faqManageQuestionsClick(params) {
    return { evid: 850, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqAppLoads' event (evid: 860)
 *
 * Event description: Send when the app loads.
 *
 * @param {faqAppLoadsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {number} num_of_categories_shown - num_of_categories_shown
 * @property {number} num_of_categories - num_of_categories
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {number} num_of_questions - num_of_questions
 * @property {string} layout_type - type of layout
 * @property {string} columns - columns: one or two
 * @property {string} category_placement - above/beside
 * @return {LogObject<faqAppLoadsParams>} LogObject<faqAppLoadsParams>
 */
export function faqAppLoads(params) {
    return { evid: 860, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqQuestionExpanded' event (evid: 861)
 *
 * Event description: uou clicks on a question to see the answer
 *
 * @param {faqQuestionExpandedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} question_order - the position of the question in the category (from top to buttom)
 * @property {GUID} visitor_id - visitor_id
 * @property {string} question_id - question_id
 * @property {string} category_id - category_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {boolean} is_all_categories - is_all_categories
 * @property {string} type - expend / strip / deep link
 * @property {number} category_order - the position of the category (in the categories order)
 * @property {string} question_name - Question that was expanded
 * @property {string} url - site url
 * @return {LogObject<faqQuestionExpandedParams>} LogObject<faqQuestionExpandedParams>
 */
export function faqQuestionExpanded(params) {
    return { evid: 861, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqShareQuestion' event (evid: 862)
 *
 * Event description: FAQ -> share question.
 *
 * @param {faqShareQuestionParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} question_order - question_order
 * @property {GUID} visitor_id - visitor_id
 * @property {number} cateogry_order - cateogry_order
 * @property {string} question_id - question_id
 * @property {string} category_id - category_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - type
 * @return {LogObject<faqShareQuestionParams>} LogObject<faqShareQuestionParams>
 */
export function faqShareQuestion(params) {
    return { evid: 862, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqSearch' event (evid: 863)
 *
 * Event description: When uou search in FAQ
 *
 * @param {faqSearchParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<faqSearchParams>} LogObject<faqSearchParams>
 */
export function faqSearch(params) {
    return { evid: 863, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqOpenQuestionToFullScreen' event (evid: 864)
 *
 * Event description: open question to full screen
 *
 * @param {faqOpenQuestionToFullScreenParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {number} question_order - question_order
 * @property {GUID} visitor_id - visitor_id
 * @property {number} cateogry_order - cateogry_order
 * @property {string} question_id - question_id
 * @property {string} category_id - category_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} type - see more / deep link
 * @return {LogObject<faqOpenQuestionToFullScreenParams>} LogObject<faqOpenQuestionToFullScreenParams>
 */
export function faqOpenQuestionToFullScreen(params) {
    return { evid: 864, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqViewAllQuestionsClick' event (evid: 865)
 *
 * Event description: When uou clicks on View all on the mobile app
 *
 * @param {faqViewAllQuestionsClickParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @return {LogObject<faqViewAllQuestionsClickParams>} LogObject<faqViewAllQuestionsClickParams>
 */
export function faqViewAllQuestionsClick(params) {
    return { evid: 865, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqChangeCategory' event (evid: 866)
 *
 * Event description: uou clicks on a question to see the answer
 *
 * @param {faqChangeCategoryParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} category_id - category_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {boolean} is_all_categories - regular category or all categories
 * @property {number} category_order - category_order
 * @return {LogObject<faqChangeCategoryParams>} LogObject<faqChangeCategoryParams>
 */
export function faqChangeCategory(params) {
    return { evid: 866, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adsWindowOpened' event (evid: 867)
 *
 * Event description: google adsense 2.0 - window opened
 *
 * @param {adsWindowOpenedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - id
 * @property {string} window_name - window name
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<adsWindowOpenedParams>} LogObject<adsWindowOpenedParams>
 */
export function adsWindowOpened(params) {
    return { evid: 867, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adsSubmitStatus' event (evid: 868)
 *
 * Event description: When user open BO and has "in review" status
 *
 * @param {adsSubmitStatusParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} description - in_review / approved / disapproved
 * @property {GUID} uuid - id
 * @property {GUID} account_id - google account id
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<adsSubmitStatusParams>} LogObject<adsSubmitStatusParams>
 */
export function adsSubmitStatus(params) {
    return { evid: 868, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseAdView' event (evid: 870)
 *
 * Event description: Ad loaded on live site
 *
 * @param {googleAdsenseAdViewParams} params - The parameters for this event
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - user id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} user_role - owner / member / anonymous
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {GUID} ad_id - ad id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<googleAdsenseAdViewParams>} LogObject<googleAdsenseAdViewParams>
 */
export function googleAdsenseAdView(params) {
    return { evid: 870, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adsUserEmbeddedConnected' event (evid: 871)
 *
 * Event description: google adsense - account connected
 *
 * @param {adsUserEmbeddedConnectedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - id
 * @property {GUID} account_id - google account id
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<adsUserEmbeddedConnectedParams>} LogObject<adsUserEmbeddedConnectedParams>
 */
export function adsUserEmbeddedConnected(params) {
    return { evid: 871, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'faqAppStartLoading' event (evid: 872)
 *
 * Event description: faq started to load
 *
 * @param {faqAppStartLoadingParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<faqAppStartLoadingParams>} LogObject<faqAppStartLoadingParams>
 */
export function faqAppStartLoading(params) {
    return { evid: 872, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printingBuilderBuilderLoaded' event (evid: 873)
 *
 * Event description: Printing Builder -> Builder Loaded.
 *
 * @param {printingBuilderBuilderLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {GUID} template_settings_id - template_settings_id
 * @property {GUID} entity_id - entity_id
 * @property {string} origin - Only for onlineprograms: edit_certificate / create_certificate
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} builderName - online program certificate / events tickets
 * @return {LogObject<printingBuilderBuilderLoadedParams>} LogObject<printingBuilderBuilderLoadedParams>
 */
export function printingBuilderBuilderLoaded(params) {
    return { evid: 873, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printingBuilderSidebarClick' event (evid: 874)
 *
 * Event description: Printing Builder -> Sidebar Click
 *
 * @param {printingBuilderSidebarClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} tabName - templates / text / badges / logos / signatures / dividers / frames / backgrounds
 * @property {GUID} template_settings_id - template_settings_id
 * @property {GUID} entity_id - entity_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} builderName - builder_name
 * @return {LogObject<printingBuilderSidebarClickParams>} LogObject<printingBuilderSidebarClickParams>
 */
export function printingBuilderSidebarClick(params) {
    return { evid: 874, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printingBuilderInsideTabClick' event (evid: 875)
 *
 * Event description: Printing Builder -> Inside Tab Click
 *
 * @param {printingBuilderInsideTabClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} templateName - template name
 * @property {string} tabName - string
 * @property {string} actionType - string
 * @property {GUID} templateId - template id
 * @property {GUID} template_settings_id - template_settings_id
 * @property {GUID} entity_id - entity_id
 * @property {string} comp_id - comp_id
 * @property {string} control - control
 * @property {GUID} app_id - app_id
 * @property {string} property - if control value is not an boolean, property notes which control property was edited
 * @property {string} value - string or null
 * @property {string} builderName - online program certificate
 * @return {LogObject<printingBuilderInsideTabClickParams>} LogObject<printingBuilderInsideTabClickParams>
 */
export function printingBuilderInsideTabClick(params) {
    return { evid: 875, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'printingBuilderClick' event (evid: 876)
 *
 * Event description: Printing Builder -> Click
 *
 * @param {printingBuilderClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} templateName - name or null
 * @property {string} tabName - main / back_modal
 * @property {string} templateId - template id or null
 * @property {GUID} template_settings_id - template_settings_id
 * @property {GUID} entity_id - entity_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} value - string
 * @property {string} builderName - online program certificate
 * @return {LogObject<printingBuilderClickParams>} LogObject<printingBuilderClickParams>
 */
export function printingBuilderClick(params) {
    return { evid: 876, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'certificatePrintingBuilderSaveDownloadClick' event (evid: 877)
 *
 * Event description: Certificate Printing Builder -> Save & Download Click
 *
 * @param {certificatePrintingBuilderSaveDownloadClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} frameId - frame or null
 * @property {GUID} biToken - msid
 * @property {boolean} isBadgeAdded - bool
 * @property {string} certificateUrl - link to certificate pdf
 * @property {string} templateName - template name
 * @property {string} dividersId - guid or null
 * @property {string} templateId - id
 * @property {GUID} template_settings_id - template_settings_id
 * @property {GUID} entity_id - entity_id
 * @property {boolean} isDefaultTemplate - template has changed
 * @property {string} badgesId - guid or null
 * @property {boolean} isSignatureAdded - is_signature_added
 * @property {string} instance_id - instance_id
 * @property {boolean} isDefault - if there is at least one change then false
 * @property {boolean} isLogoAdded - bool
 * @property {string} builderName - builderName
 * @return {LogObject<certificatePrintingBuilderSaveDownloadClickParams>} LogObject<certificatePrintingBuilderSaveDownloadClickParams>
 */
export function certificatePrintingBuilderSaveDownloadClick(params) {
    return { evid: 877, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareSharedFolderAddOnAdded' event (evid: 878)
 *
 * Event description: shared folder add-on added
 *
 * @param {fileShareSharedFolderAddOnAddedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<fileShareSharedFolderAddOnAddedParams>} LogObject<fileShareSharedFolderAddOnAddedParams>
 */
export function fileShareSharedFolderAddOnAdded(params) {
    return { evid: 878, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareUploadButtonAdded' event (evid: 879)
 *
 * Event description: Upload button added
 *
 * @param {fileShareUploadButtonAddedParams} params - The parameters for this event
 * @property {GUID} app_site_id - guid
 * @property {string} instanceId - instance_id
 * @property {GUID} biToken - guid
 * @property {string} instance_id - instance_id
 * @return {LogObject<fileShareUploadButtonAddedParams>} LogObject<fileShareUploadButtonAddedParams>
 */
export function fileShareUploadButtonAdded(params) {
    return { evid: 879, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareUploadButtonSettings' event (evid: 880)
 *
 * Event description: user save upload button settings
 *
 * @param {fileShareUploadButtonSettingsParams} params - The parameters for this event
 * @property {GUID} app_site_id - guid
 * @property {string} instanceId - instance_id
 * @property {boolean} hide_from_visitors_without_permissions - true / false
 * @property {string} upload_destination_type - main_folder / specific_folder
 * @property {boolean} custom_role_permissions - true / false
 * @property {string} specific_folder_type - select_folder / site_visitor_should_select / null
 * @property {string} button_text - default / string
 * @property {GUID} biToken - guid
 * @property {GUID} upload_destination_id - folder_id
 * @property {string} button_icon - default / icon_name
 * @property {boolean} admins_permissions - true / false
 * @property {boolean} all_members_permissions - true / false
 * @property {boolean} pricing_plan_permissions - true / false
 * @property {string} instance_id - instance_id
 * @return {LogObject<fileShareUploadButtonSettingsParams>} LogObject<fileShareUploadButtonSettingsParams>
 */
export function fileShareUploadButtonSettings(params) {
    return { evid: 880, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareUploadButtonState' event (evid: 881)
 *
 * Event description: file share -> upload button state.
 *
 * @param {fileShareUploadButtonStateParams} params - The parameters for this event
 * @property {GUID} app_site_id - guid
 * @property {GUID} instance_id - instance_id
 * @property {string} instanceId - instance_id
 * @property {string} state - error_flow_no_permission / error_flow_private_profile / make_public_profile
 * @property {GUID} biToken - guid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {string} action_type - click_on_action / click_on_button
 * @return {LogObject<fileShareUploadButtonStateParams>} LogObject<fileShareUploadButtonStateParams>
 */
export function fileShareUploadButtonState(params) {
    return { evid: 881, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gridGeneratorAddLayout' event (evid: 885)
 *
 * Event description: Grid Generator - Add Layout
 *
 * @param {gridGeneratorAddLayoutParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} layout_id - guid
 * @property {string} type - auto / manual
 * @property {string} instance_id - instance_id
 * @return {LogObject<gridGeneratorAddLayoutParams>} LogObject<gridGeneratorAddLayoutParams>
 */
export function gridGeneratorAddLayout(params) {
    return { evid: 885, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gridGeneratorLayoutLoaded' event (evid: 886)
 *
 * Event description: Grid Generator - Layout Loaded
 *
 * @param {gridGeneratorLayoutLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {number} margin - margin
 * @property {string} device_view - computer / mobile
 * @property {GUID} biToken - msid
 * @property {number} cell_size - cell size
 * @property {number} row_height - row height
 * @property {number} column_width - col width
 * @property {string} page_id - id of website page
 * @property {number} colum_number - col num
 * @property {number} row_number - row num
 * @property {string} color_code - color code
 * @property {string} layout_id - id
 * @property {boolean} snap_to_grid - true / false
 * @property {number} gutter - gutter
 * @property {string} type_location - stretch / left / right / center/ stretch / top / bottom
 * @property {string} type - columns / rows / grid
 * @property {string} instance_id - instance_id
 * @return {LogObject<gridGeneratorLayoutLoadedParams>} LogObject<gridGeneratorLayoutLoadedParams>
 */
export function gridGeneratorLayoutLoaded(params) {
    return { evid: 886, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gridGeneratorButtonClick' event (evid: 887)
 *
 * Event description: Grid Generator - Button Click
 *
 * @param {gridGeneratorButtonClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} button_name - add_layout / delete / hide
 * @property {string} instance_id - instance_id
 * @return {LogObject<gridGeneratorButtonClickParams>} LogObject<gridGeneratorButtonClickParams>
 */
export function gridGeneratorButtonClick(params) {
    return { evid: 887, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTextCreatorPanelLoaded' event (evid: 888)
 *
 * Event description: AI Text Creator panel loaded in bizmngr
 *
 * @param {aiTextCreatorPanelLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} model_guid - model version
 * @property {string} entity_description - entity description
 * @property {GUID} biToken - msid
 * @property {string} input_type - this is list of available inputs in text creator ('businessType' / 'businessName' / 'customSectionType' / 'freetext')
 * @property {string} panel_name - panel version
 * @property {string} text_type - title' / 'paragraph' /
 * @property {boolean} is_general_flow - true / false
 * @property {string} entity_id - entity_id
 * @property {string} app_name - STORES / ...
 * @property {string} instance_id - instance_id
 * @return {LogObject<aiTextCreatorPanelLoadedParams>} LogObject<aiTextCreatorPanelLoadedParams>
 */
export function aiTextCreatorPanelLoaded(params) {
    return { evid: 888, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTextCreatorCreateTextClick' event (evid: 889)
 *
 * Event description: AI Text Creator - create text CTA clicked
 *
 * @param {aiTextCreatorCreateTextClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} model_guid - model version
 * @property {string} entity_description - entity_description
 * @property {GUID} biToken - msid
 * @property {string} input_type - this is list of available inputs in text creator ('businessType' / 'businessName' / 'customSectionType' / 'freetext')
 * @property {string} query - User input / prompt name + version
 * @property {string} panel_name - panel version
 * @property {string} text_type - title' / 'paragraph'
 * @property {boolean} is_general_flow - true / false
 * @property {string} entity_id - entity id (example - product id for stores)
 * @property {string} app_name - STORES / ...
 * @property {string} instance_id - instance_id
 * @return {LogObject<aiTextCreatorCreateTextClickParams>} LogObject<aiTextCreatorCreateTextClickParams>
 */
export function aiTextCreatorCreateTextClick(params) {
    return { evid: 889, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTextCreatorTextGenerationRequest' event (evid: 890)
 *
 * Event description: AI Text Creator - text generation request
 *
 * @param {aiTextCreatorTextGenerationRequestParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} model_guid - model version
 * @property {string} entity_description - entity_description
 * @property {GUID} biToken - msid
 * @property {string} input_type - this is list of available inputs in text creator ('businessType' / 'businessName' / 'customSectionType' / 'freetext')
 * @property {string} query - User input / prompt name + version
 * @property {string} panel_name - panel version
 * @property {string} text_type - title' / 'paragraph'
 * @property {boolean} is_general_flow - true / false
 * @property {string} entity_id - entity id (example - product id for stores)
 * @property {string} app_name - STORES / ...
 * @property {string} request_id - id
 * @property {string} instance_id - instance_id
 * @return {LogObject<aiTextCreatorTextGenerationRequestParams>} LogObject<aiTextCreatorTextGenerationRequestParams>
 */
export function aiTextCreatorTextGenerationRequest(params) {
    return { evid: 890, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTextCreatorTextInputError' event (evid: 891)
 *
 * Event description: AI Text Creator - text input error
 *
 * @param {aiTextCreatorTextInputErrorParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} model_guid - model version
 * @property {string} entity_description - entity_description
 * @property {GUID} biToken - msid
 * @property {string} input_type - this is list of available inputs in text creator ('businessType' / 'businessName' / 'customSectionType' / 'freetext')
 * @property {string} query - User input / prompt name + version
 * @property {string} panel_name - panel version
 * @property {string} text_type - title' / 'paragraph'
 * @property {boolean} is_general_flow - true / false
 * @property {string} error_type - mandatory_text_required / offensive_content
 * @property {string} entity_id - entity id (example - product id for stores)
 * @property {string} app_name - STORES / ...
 * @property {string} request_id - id
 * @property {string} instance_id - instance_id
 * @return {LogObject<aiTextCreatorTextInputErrorParams>} LogObject<aiTextCreatorTextInputErrorParams>
 */
export function aiTextCreatorTextInputError(params) {
    return { evid: 891, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTextCreatorTextGenerationResponse' event (evid: 892)
 *
 * Event description: AI Text Creator - text generation response
 *
 * @param {aiTextCreatorTextGenerationResponseParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} model_guid - model version
 * @property {string} entity_description - entity_description
 * @property {string} model - {model version name , setting etc.}
 * @property {GUID} biToken - msid
 * @property {string} query_output - model output
 * @property {string} input_type - this is list of available inputs in text creator ('businessType' / 'businessName' / 'customSectionType' / 'freetext')
 * @property {string} query - User input / prompt name + version
 * @property {string} panel_name - panel version
 * @property {string} text_type - 'title' / 'paragraph'
 * @property {boolean} is_general_flow - true / false
 * @property {string} entity_id - entity id (example - product id for stores)
 * @property {string} token - prompt / completion tokens
 * @property {string} app_name - STORES / ...
 * @property {string} request_id - id
 * @property {string} instance_id - instance_id
 * @property {string} response_type - OK / error
 * @return {LogObject<aiTextCreatorTextGenerationResponseParams>} LogObject<aiTextCreatorTextGenerationResponseParams>
 */
export function aiTextCreatorTextGenerationResponse(params) {
    return { evid: 892, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiTextCreatorUseCopyTextOutput' event (evid: 893)
 *
 * Event description: AI Text Creator - Use / Copy Text Output
 *
 * @param {aiTextCreatorUseCopyTextOutputParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} model_guid - model version
 * @property {string} entity_description - entity_description
 * @property {string} option_text - selected option
 * @property {string} model - {model version name , setting etc.}
 * @property {GUID} biToken - msid
 * @property {string} query_output - query_output
 * @property {string} option - text option [1/2/3]
 * @property {string} input_type - this is list of available inputs in text creator ('businessType' / 'businessName' / 'customSectionType' / 'freetext')
 * @property {string} query - User input / prompt name + version
 * @property {string} panel_name - panel version
 * @property {string} text_type - title' / 'paragraph'
 * @property {boolean} is_general_flow - true / false
 * @property {string} entity_id - entity id (example - product id for stores)
 * @property {string} token - prompt / completion tokens
 * @property {string} app_name - STORES / ...
 * @property {string} request_id - id
 * @property {string} instance_id - instance_id
 * @property {string} action_type - copy / use_text
 * @property {string} response_type - OK
 * @return {LogObject<aiTextCreatorUseCopyTextOutputParams>} LogObject<aiTextCreatorUseCopyTextOutputParams>
 */
export function aiTextCreatorUseCopyTextOutput(params) {
    return { evid: 893, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gdprServiceRequestSent' event (evid: 894)
 *
 * Event description: GDPR service -> request sent
 *
 * @param {gdprServiceRequestSentParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} apps_list - list of apps in request
 * @property {string} request_type - delete / get_data
 * @property {string} request_id - id of request
 * @property {string} instance_id - instance_id
 * @return {LogObject<gdprServiceRequestSentParams>} LogObject<gdprServiceRequestSentParams>
 */
export function gdprServiceRequestSent(params) {
    return { evid: 894, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'gdprServiceRequestResponse' event (evid: 895)
 *
 * Event description: GDPR service -> request response
 *
 * @param {gdprServiceRequestResponseParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} request_type - delete / get_data
 * @property {string} response - OK or error description
 * @property {string} request_id - id of request
 * @property {string} app_id - app id
 * @property {string} instance_id - instance_id
 * @return {LogObject<gdprServiceRequestResponseParams>} LogObject<gdprServiceRequestResponseParams>
 */
export function gdprServiceRequestResponse(params) {
    return { evid: 895, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorPluginLoaded' event (evid: 896)
 *
 * Event description: Plugin Loaded in Editor
 *
 * @param {editorPluginLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} page_id - id of editor page where plugin loaded
 * @property {string} plugin_name - plugin_name
 * @property {string} instance_id - instance_id
 * @return {LogObject<editorPluginLoadedParams>} LogObject<editorPluginLoadedParams>
 */
export function editorPluginLoaded(params) {
    return { evid: 896, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorPluginButtonClick' event (evid: 897)
 *
 * Event description: Button Click in plugins
 *
 * @param {editorPluginButtonClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} button_name - button_name
 * @property {string} page_id - id of editor page where plugin loaded
 * @property {string} plugin_name - plugin_name
 * @property {string} instance_id - instance_id
 * @return {LogObject<editorPluginButtonClickParams>} LogObject<editorPluginButtonClickParams>
 */
export function editorPluginButtonClick(params) {
    return { evid: 897, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editorPluginItemAction' event (evid: 898)
 *
 * Event description: editor plugin - item action
 *
 * @param {editorPluginItemActionParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} item_id - item_id
 * @property {string} action_name - action_name
 * @property {GUID} biToken - msid
 * @property {string} page_id - page_id
 * @property {string} item_name - item_name
 * @property {string} plugin_name - plugin_name
 * @property {string} instance_id - instance_id
 * @return {LogObject<editorPluginItemActionParams>} LogObject<editorPluginItemActionParams>
 */
export function editorPluginItemAction(params) {
    return { evid: 898, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseWindowStartLoading' event (evid: 899)
 *
 * Event description: google adsense - start loading
 *
 * @param {googleAdsenseWindowStartLoadingParams} params - The parameters for this event
 * @property {GUID} app_site_id - .
 * @property {GUID} biToken - .
 * @property {GUID} uuid - id
 * @property {string} window_name - window name
 * @property {GUID} msid - .
 * @property {string} instance_id - .
 * @return {LogObject<googleAdsenseWindowStartLoadingParams>} LogObject<googleAdsenseWindowStartLoadingParams>
 */
export function googleAdsenseWindowStartLoading(params) {
    return { evid: 899, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'outputTokenReceivedSrc63Evid9' event (evid: 9)
 *
 * Event description: Get output from the model
 *
 * @param {outputTokenReceivedSrc63Evid9Params} params - The parameters for this event
 * @property {string} vertical - Where the product is called from
 * @property {string} type - Type of generator: panel, component, popover
 * @property {number} cost - Cost of the request
 * @return {LogObject<outputTokenReceivedSrc63Evid9Params>} LogObject<outputTokenReceivedSrc63Evid9Params>
 */
export function outputTokenReceivedSrc63Evid9(params) {
    return { evid: 9, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareUploadButtonAddOnAdded' event (evid: 900)
 *
 * Event description: file share -> upload button add-on added
 *
 * @param {fileShareUploadButtonAddOnAddedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {GUID} biToken - msid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<fileShareUploadButtonAddOnAddedParams>} LogObject<fileShareUploadButtonAddOnAddedParams>
 */
export function fileShareUploadButtonAddOnAdded(params) {
    return { evid: 900, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'countdownClockAppPublishedNewEvent' event (evid: 901)
 *
 * Event description: Countdown Clock - App published
 *
 * @param {countdownClockAppPublishedNewEventParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} clock_type - fixed / repeats / set_per_visitor
 * @property {GUID} biToken - msid
 * @property {string} digit_animation - none / fade / slide_down /
 * @property {GUID} uuid - guid
 * @property {string} unit_label_text - {days_text: Days, hours_text: Hours, minutes_text: Minutes , seconds_text: Seconds}
 * @property {boolean} show_unit_labels - true / false
 * @property {string} present_name - present_name
 * @property {string} widget_elements - json converted to string
 * @property {string} settings_details - settings_details (json converted to string)
 * @property {string} comp_id - comp_id
 * @property {string} layout - box/strip
 * @property {boolean} show_digit_separator - true / false
 * @property {boolean} show_message - true/false
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<countdownClockAppPublishedNewEventParams>} LogObject<countdownClockAppPublishedNewEventParams>
 */
export function countdownClockAppPublishedNewEvent(params) {
    return { evid: 901, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'countdownClockNavigation' event (evid: 902)
 *
 * Event description: Countdown Clock - Navigation
 *
 * @param {countdownClockNavigationParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - id
 * @property {string} comp_id - id
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @property {string} view - clock / end_message
 * @return {LogObject<countdownClockNavigationParams>} LogObject<countdownClockNavigationParams>
 */
export function countdownClockNavigation(params) {
    return { evid: 902, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoButtonClick' event (evid: 903)
 *
 * Event description: site promo -> button click
 *
 * @param {sitePromoButtonClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} button_name - button_name
 * @property {string} parent_view - parent_view
 * @property {string} entity_id - entity_id
 * @property {string} entity - entity
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<sitePromoButtonClickParams>} LogObject<sitePromoButtonClickParams>
 */
export function sitePromoButtonClick(params) {
    return { evid: 903, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoElementLoaded' event (evid: 904)
 *
 * Event description: site promo -> element loaded
 *
 * @param {sitePromoElementLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} element_name - element_name
 * @property {string} element_type - toast / screen
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<sitePromoElementLoadedParams>} LogObject<sitePromoElementLoadedParams>
 */
export function sitePromoElementLoaded(params) {
    return { evid: 904, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoPromoCreated' event (evid: 905)
 *
 * Event description: site promo -> promo created
 *
 * @param {sitePromoPromoCreatedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} promo_id - promo_id
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @property {string} promo_data - json with promo details
 * @return {LogObject<sitePromoPromoCreatedParams>} LogObject<sitePromoPromoCreatedParams>
 */
export function sitePromoPromoCreated(params) {
    return { evid: 905, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoPromoEdited' event (evid: 906)
 *
 * Event description: site promo -> promo edited
 *
 * @param {sitePromoPromoEditedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} promo_id - promo_id
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @property {string} promo_data - json with promo details
 * @return {LogObject<sitePromoPromoEditedParams>} LogObject<sitePromoPromoEditedParams>
 */
export function sitePromoPromoEdited(params) {
    return { evid: 906, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoStatusChanged' event (evid: 907)
 *
 * Event description: site promo -> status changed
 *
 * @param {sitePromoStatusChangedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} new_status - arhived / unarhieved / deleted / draft / pending / incomplete / expired / active
 * @property {GUID} promo_id - id
 * @property {string} previous_status - arhived / unarhieved / deleted / draft / pending / incomplete / expired / active
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<sitePromoStatusChangedParams>} LogObject<sitePromoStatusChangedParams>
 */
export function sitePromoStatusChanged(params) {
    return { evid: 907, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoPromoPublished' event (evid: 908)
 *
 * Event description: site promo -> promo published
 *
 * @param {sitePromoPromoPublishedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {boolean} stretch - true/false
 * @property {string} promo_id - promo_id
 * @property {string} widget_elements - widget_elements
 * @property {number} pause_between_images - pause_between_images
 * @property {string} widget_layout - widget_layout
 * @property {GUID} msid - msid
 * @property {string} preset_id - design preset
 * @property {string} instance_id - instance_id
 * @return {LogObject<sitePromoPromoPublishedParams>} LogObject<sitePromoPromoPublishedParams>
 */
export function sitePromoPromoPublished(params) {
    return { evid: 908, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoUouView' event (evid: 909)
 *
 * Event description: site promo -> uou view
 *
 * @param {sitePromoUouViewParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {string} template_type - announcement
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} promo_type - coupon / automatic_discount/ site_page
 * @property {GUID} visitor_id - visitor_id
 * @property {string} cta_id - cta_id
 * @property {GUID} promo_id - promo_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<sitePromoUouViewParams>} LogObject<sitePromoUouViewParams>
 */
export function sitePromoUouView(params) {
    return { evid: 909, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sitePromoUouCtaClick' event (evid: 910)
 *
 * Event description: site promo -> uou cta click
 *
 * @param {sitePromoUouCtaClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} instance_id - instance_id
 * @property {string} template_type - announcement
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} promo_type - coupon / automatic_discount / site_page
 * @property {GUID} visitor_id - visitor_id
 * @property {string} cta_id - cta id
 * @property {GUID} promo_id - promo_id
 * @property {string} comp_id - comp_id
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @return {LogObject<sitePromoUouCtaClickParams>} LogObject<sitePromoUouCtaClickParams>
 */
export function sitePromoUouCtaClick(params) {
    return { evid: 910, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileShareBoButtonClick' event (evid: 911)
 *
 * Event description: file share -> BO button click
 *
 * @param {fileShareBoButtonClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} screen_name - screen_name
 * @property {string} file_id - id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} data - <>
 * @property {string} button_name - button_name
 * @property {number} folder_id - id
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @property {string} button_origin - button_origin
 * @return {LogObject<fileShareBoButtonClickParams>} LogObject<fileShareBoButtonClickParams>
 */
export function fileShareBoButtonClick(params) {
    return { evid: 911, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerBmPageLoaded' event (evid: 913)
 *
 * Event description: storage manager - BM page loaded
 *
 * @param {storageManagerBmPageLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} files_details - <json converted to string - records file type and number of files with such type>
 * @property {GUID} biToken - msid
 * @property {number} storage_used - number of storage used by user
 * @property {GUID} uuid - uuid
 * @property {number} files_count - files_count
 * @property {number} storage_limit - number of storage available for users
 * @property {string} storage_details - <json converted to string - records file type and storage of files with such type
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerBmPageLoadedParams>} LogObject<storageManagerBmPageLoadedParams>
 */
export function storageManagerBmPageLoaded(params) {
    return { evid: 913, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerUpgradeClick' event (evid: 914)
 *
 * Event description: storage manager - Upgrade to Premium click
 *
 * @param {storageManagerUpgradeClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {number} storage_used - number of storage used by user
 * @property {GUID} uuid - uuid
 * @property {number} files_count - files_count
 * @property {number} storage_limit - number of storage available for user
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerUpgradeClickParams>} LogObject<storageManagerUpgradeClickParams>
 */
export function storageManagerUpgradeClick(params) {
    return { evid: 914, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerPlansDetails' event (evid: 915)
 *
 * Event description: trigger - when user clicks learn more>
 *
 * @param {storageManagerPlansDetailsParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {number} storage_used - number of storage used by user
 * @property {GUID} uuid - uuid
 * @property {number} files_count - files_count
 * @property {number} storage_limit - number of storage available for users
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerPlansDetailsParams>} LogObject<storageManagerPlansDetailsParams>
 */
export function storageManagerPlansDetails(params) {
    return { evid: 915, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerPreviewFile' event (evid: 916)
 *
 * Event description: storage manager - Preview file
 *
 * @param {storageManagerPreviewFileParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} file_id - file_id
 * @property {GUID} biToken - msid
 * @property {number} file_size - file_size
 * @property {GUID} uuid - uuid
 * @property {string} file_type - file_type
 * @property {boolean} is_bulk_action - is_bulk_action
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerPreviewFileParams>} LogObject<storageManagerPreviewFileParams>
 */
export function storageManagerPreviewFile(params) {
    return { evid: 916, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerDownloadFile' event (evid: 917)
 *
 * Event description: storage manager - Download file
 *
 * @param {storageManagerDownloadFileParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} file_id - file id
 * @property {GUID} biToken - msid
 * @property {number} file_size - file size
 * @property {GUID} uuid - uuid
 * @property {string} file_type - file type
 * @property {boolean} is_bulk_action - is_bulk_action
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerDownloadFileParams>} LogObject<storageManagerDownloadFileParams>
 */
export function storageManagerDownloadFile(params) {
    return { evid: 917, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerMoveFileToTrash' event (evid: 918)
 *
 * Event description: storage manager - Move file to trash
 *
 * @param {storageManagerMoveFileToTrashParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} file_id - file id
 * @property {GUID} biToken - msid
 * @property {number} file_size - file size
 * @property {GUID} uuid - uuid
 * @property {string} file_type - file type
 * @property {boolean} is_bulk_action - is_bulk_action
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerMoveFileToTrashParams>} LogObject<storageManagerMoveFileToTrashParams>
 */
export function storageManagerMoveFileToTrash(params) {
    return { evid: 918, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerPermanentlyDeleteFile' event (evid: 919)
 *
 * Event description: storage manager - Permanently delete file
 *
 * @param {storageManagerPermanentlyDeleteFileParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} file_id - file id
 * @property {GUID} biToken - msid
 * @property {number} file_size - file size
 * @property {GUID} uuid - uuid
 * @property {string} file_type - file type
 * @property {boolean} is_bulk_action - is_bulk_action
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerPermanentlyDeleteFileParams>} LogObject<storageManagerPermanentlyDeleteFileParams>
 */
export function storageManagerPermanentlyDeleteFile(params) {
    return { evid: 919, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerFilterApplied' event (evid: 921)
 *
 * Event description: storage manager - Filter applied
 *
 * @param {storageManagerFilterAppliedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {string} filter_origin - filter origin
 * @property {GUID} uuid - uuid
 * @property {string} filter_name - filter name
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerFilterAppliedParams>} LogObject<storageManagerFilterAppliedParams>
 */
export function storageManagerFilterApplied(params) {
    return { evid: 921, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'storageManagerNavigationClick' event (evid: 922)
 *
 * Event description: storage manager - Navigation click
 *
 * @param {storageManagerNavigationClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} action_name - navigation action
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<storageManagerNavigationClickParams>} LogObject<storageManagerNavigationClickParams>
 */
export function storageManagerNavigationClick(params) {
    return { evid: 922, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogAppsScreenLoaded' event (evid: 923)
 *
 * Event description: Blog Apps - Screen Loaded
 *
 * @param {blogAppsScreenLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} explore_apps - list of recommended apps
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @property {string} installed_apps - list of installed apps
 * @return {LogObject<blogAppsScreenLoadedParams>} LogObject<blogAppsScreenLoadedParams>
 */
export function blogAppsScreenLoaded(params) {
    return { evid: 923, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogAppsButtonClick' event (evid: 924)
 *
 * Event description: Blog Apps - Button Click
 *
 * @param {blogAppsButtonClickParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {string} element_id - element id
 * @property {string} action_name - action_name
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} element_type - element type
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<blogAppsButtonClickParams>} LogObject<blogAppsButtonClickParams>
 */
export function blogAppsButtonClick(params) {
    return { evid: 924, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'blogAppsAppInstalled' event (evid: 925)
 *
 * Event description: Blog Apps - App Installed
 *
 * @param {blogAppsAppInstalledParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app id
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<blogAppsAppInstalledParams>} LogObject<blogAppsAppInstalledParams>
 */
export function blogAppsAppInstalled(params) {
    return { evid: 925, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseInitEmbeddedConnectScriptLoaded' event (evid: 926)
 *
 * Event description: Monitoring BI
 *
 * @param {googleAdsenseInitEmbeddedConnectScriptLoadedParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<googleAdsenseInitEmbeddedConnectScriptLoadedParams>} LogObject<googleAdsenseInitEmbeddedConnectScriptLoadedParams>
 */
export function googleAdsenseInitEmbeddedConnectScriptLoaded(params) {
    return { evid: 926, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseAppStartLoading' event (evid: 927)
 *
 * Event description: Monitoring BI
 *
 * @param {googleAdsenseAppStartLoadingParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<googleAdsenseAppStartLoadingParams>} LogObject<googleAdsenseAppStartLoadingParams>
 */
export function googleAdsenseAppStartLoading(params) {
    return { evid: 927, src: 63, endpoint: '', params };
}
/**
 * A function to create a log object for the 'googleAdsenseStartAccountConnection' event (evid: 928)
 *
 * Event description: google adsense - start account connection
 *
 * @param {googleAdsenseStartAccountConnectionParams} params - The parameters for this event
 * @property {GUID} app_site_id - app_site_id
 * @property {GUID} biToken - msid
 * @property {GUID} uuid - uuid
 * @property {GUID} msid - msid
 * @property {string} instance_id - instance_id
 * @return {LogObject<googleAdsenseStartAccountConnectionParams>} LogObject<googleAdsenseStartAccountConnectionParams>
 */
export function googleAdsenseStartAccountConnection(params) {
    return { evid: 928, src: 63, endpoint: '', params };
}
//# sourceMappingURL=index.js.map